"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockHomePageBanners = exports.mockTeamsLeaderboarddData = exports.mockTopUsersLeaderboarddData = exports.mockUsersLeaderboarddData = exports.mockCompletedData = exports.mockOtherMemebersTaken = exports.mockLeanContent = exports.mockeRecentlyAddedContent = exports.mockAssignedContent = exports.mockSkillTree = exports.mockCourses = exports.mockLessons = void 0;
var learningPathsApi_1 = require("./learningPathsApi");
var videoTutorialApi_1 = require("./videoTutorialApi");
exports.mockLessons = {
    lessons: [
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            name: 'sql_injection',
            displayName: 'SQL Injection Long Line Name As Default',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            type: 'system',
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 144,
            uuid: '6167f2408df887dad076a616',
            name: 'xxe_processing',
            displayName: 'XXE Processing',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/xxe_processing.png',
            type: 'system',
            cwe: 'CWE-611',
            owasp: 'A5: Security Misconfiguration ',
            sans: null,
            isCompleted: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/xxe_processing',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
        {
            id: 145,
            uuid: '6167f23bc27d3d92df9529f5',
            name: 'command_injection',
            displayName: 'Command Injection',
            duration: '5-8',
            description: 'lesson very very very very very very very very very long description ',
            iconUrl: 'https://content.codebashing.com/courses-assets/command_injection.png',
            type: 'system',
            cwe: 'CWE-77',
            owasp: 'A3: Injection',
            sans: null,
            isCompleted: false,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/command_injection',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: 100,
        },
    ],
};
exports.mockCourses = {
    courses: [
        {
            id: 28,
            uuid: '3cd94db9-70e2-4754-b40c-a91bacd06c9d',
            displayName: 'Python Advanced 2',
            description: 'Learn how to secure Python web applications and practice recognizing different attacks.',
            tagline: 'Practice and learn how to secure Python web applications.',
            iconUrl: 'https://codebashing-dev-content.s3.eu-west-1.amazonaws.com/courses-assets/Python_Advanced_2_Course_Icon.svg',
            name: 'python_advanced_lessons2',
            publishedAt: '2021-02-17T18:51:43.000Z',
            activeOnLean: false,
            isPrimary: true,
            assignedToMe: true,
            score: 0,
            completionPercentage: 0,
            progress: 'completed',
            hasCertificate: true,
            isSystem: true,
            numberOfLessons: 9,
            nextLessonUrl: '/courses/python_advanced_lessons2/lessons/horizontal_privilege_escalation',
        },
        {
            id: 28,
            uuid: '3cd94db9-70e2-4754-b40c-a91bacd06c9d',
            displayName: 'Python Advanced 2',
            description: 'Learn how to secure Python web applications and practice recognizing different attacks.',
            tagline: 'Practice and learn how to secure Python web applications.',
            iconUrl: 'https://codebashing-dev-content.s3.eu-west-1.amazonaws.com/courses-assets/Python_Advanced_2_Course_Icon.svg',
            name: 'python_advanced_lessons2',
            publishedAt: '2021-02-17T18:51:43.000Z',
            activeOnLean: false,
            isPrimary: true,
            assignedToMe: true,
            score: 0,
            completionPercentage: 0,
            progress: 'completed',
            hasCertificate: false,
            isSystem: true,
            numberOfLessons: 9,
            nextLessonUrl: '/courses/python_advanced_lessons2/lessons/horizontal_privilege_escalation',
        },
    ],
    lessons: [
        {
            id: 144,
            uuid: '6167f2408df887dad076a616',
            displayName: 'XXE Processing',
            description: 'XML External Entity (XXE) Processing is a type of application security vulnerability whereby a malicious user can attack poorly configured/implemented XML parser within an application. Malicious external entity references can be forced by an attacker, which results in unauthorized read-access to sensitive files on the server that the XML parser runs from. Denial of Service is another potential outcome. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/xxe_processing.png',
            name: 'xxe_processing',
            type: 'system',
            activeOnLean: true,
            isCompleted: true,
            progress: 'completed',
            cwe: 'CWE-611',
            owasp: 'A5: Security Misconfiguration ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: '250',
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/xxe_processing',
        },
        {
            id: 145,
            uuid: '6167f23bc27d3d92df9529f5',
            displayName: 'Command Injection',
            description: 'A Command Injection vulnerability, when exploited by a malicious user, results in execution of arbitrary system commands on the host operating system. Command Injection attacks are possible when an application passes unsafe user supplied data (forms, cookies, HTTP headers, etc) to a system command. The malicious system command is run server side with the same privileges as the application. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/command_injection.png',
            name: 'command_injection',
            type: 'system',
            activeOnLean: true,
            isCompleted: true,
            progress: 'completed',
            cwe: 'CWE-77',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: '1750',
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/command_injection',
        },
        {
            id: 3,
            uuid: '6167f23fc27d3db2e6952a04',
            displayName: 'SQL Injection',
            description: 'SQL Injection is a type of application security vulnerability whereby a malicious user is able to manipulate the SQL statements that the application sends to the backend database server for execution. A successful SQL injection attack exposes the data of the underlying database directly to the attacker. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            name: 'sql_injection',
            type: 'system',
            activeOnLean: true,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/sql_injection',
        },
        {
            id: 488,
            uuid: '6252a7a677c3633d860d3571',
            displayName: 'Password Storage',
            description: 'Databases containing emails, passwords, and other sensitive us',
            duration: '5-8',
            iconUrl: null,
            name: 'password_storage',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Cryptography ',
            url: '/courses/cryptography/lessons/password_storage',
        },
        {
            id: 487,
            uuid: '6252a5c70bb6fc78c1641745',
            displayName: 'Encoding vs. Hashing vs. Encryption',
            description: 'Databases containing emails, passwords, and other sensitive user data are among the most sought-after trophies for hackers. There exist different approaches to the protection of sensitive data - especially pas',
            duration: '5-8',
            iconUrl: null,
            name: 'encoding_vs_hashing_vs_encryption',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Cryptography ',
            url: '/courses/cryptography/lessons/encoding_vs_hashing_vs_encryption',
        },
        {
            id: 621,
            uuid: '66fc9fed-2c97-43b4-a93f-f75c4f1f525a',
            displayName: 'CISO Test',
            description: 'dfdf',
            duration: '',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customLessons/customLesson-1.svg',
            name: 'ciso_test1697964012',
            type: 'custom',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: null,
            url: '/courses/custom_lessons/lessons/ciso_test1697964012',
        },
        {
            id: 627,
            uuid: '7f1043d4-fab7-445b-ab47-c35e771f7a25',
            displayName: 'CISO test 2',
            description: 'CISO test 2',
            duration: '',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customLessons/customLesson-1.svg',
            name: 'ciso_test_21698172743',
            type: 'custom',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: null,
            url: '/courses/custom_lessons/lessons/ciso_test_21698172743',
        },
        {
            id: 628,
            uuid: '5c17c1ee-aef0-4871-80ce-6b48b8cad4fa',
            displayName: 'ciso 3 test lesson',
            description: 'ciso 3 test lesson',
            duration: '',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customLessons/customLesson-10.svg',
            name: 'ciso_3_test_lesson1698914526',
            type: 'custom',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: null,
            url: '/courses/custom_lessons/lessons/ciso_3_test_lesson1698914526',
        },
        {
            id: 629,
            uuid: 'c465930d-d68d-4f67-9f91-d1fcef190180',
            displayName: 'ciso test 4',
            description: 'ciso test 4',
            duration: '',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customLessons/customLesson-10.svg',
            name: 'ciso_test_41698915668',
            type: 'custom',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: null,
            url: '/courses/custom_lessons/lessons/ciso_test_41698915668',
        },
        {
            id: 630,
            uuid: '90937db0-777c-4d62-af0a-f9d99c03abab',
            displayName: 'ciso test 5',
            description: 'ciso test 5',
            duration: '',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customLessons/customLesson-10.svg',
            name: 'ciso_test_51698917645',
            type: 'custom',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: null,
            url: '/courses/custom_lessons/lessons/ciso_test_51698917645',
        },
        {
            id: 146,
            uuid: '6167f23f8df88728e476a610',
            displayName: 'Session Fixation',
            description: 'Session Fixation is a type of application vulnerability where an application doe Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/session_fixation.png',
            name: 'session_fixation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-384',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/session_fixation',
        },
        {
            id: 147,
            uuid: '6167f2408df8872a0e76a613',
            displayName: 'Use of Insufficiently Random Values',
            description: 'Insufficiently Random Values are an application security vulnerability whereby the application generates predictable values in sensitive areas of code that absolutely require strict randomness (unpredictability). As a result it may be possible for an attacker to predict the next value generated by the application to defeat cryptographic routines, access sensitive information, or impersonate another user. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/use_of_insufficiently_random_values.png',
            name: 'use_of_insufficiently_random_values',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-330',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/use_of_insufficiently_random_values',
        },
        {
            id: 148,
            uuid: '6167f23ec27d3d4f8d952a01',
            displayName: 'Reflected XSS',
            description: 'Unlike Persistent XSS',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/reflected_xss.png',
            name: 'reflected_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: true,
            progress: 'completed',
            cwe: 'CWE-79',
            owasp: 'A3: Injection',
            sans: 'SANS-#4',
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: '250',
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/reflected_xss',
        },
        {
            id: 149,
            uuid: '6167f23f2479f1d557d557e3',
            displayName: 'Stored (Persistent) XSS',
            description: 'Persistent Cross-Site Scripting (XSS) is an application vulnerability whereby a malicious user tricks a web application into storing attacker-supplied script code which is then later served to unsuspecting user(s) of the application. The attacker-supplied script code runs on the client-side system of other end user(s) of the application. This type of vulnerability is widespread and affects web applications that utilize (unvalidated) user-supplied input to generate (unencoded) application output, that is served to users. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/stored_persistent_xss.png',
            name: 'stored_persistent_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/stored_persistent_xss',
        },
        {
            id: 150,
            uuid: '6167f23c8df887633876a607',
            displayName: 'DOM XSS',
            description: 'Document Object Model (DOM) Based XSS is a type of XSS attack wherein the attac',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/dom_xss.png',
            name: 'dom_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-79',
            owasp: 'A3: Injection',
            sans: 'SANS-#4',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/dom_xss',
        },
        {
            id: 151,
            uuid: '6167f23c2479f12101d557d7',
            displayName: 'Directory (Path) Traversal',
            description: 'Directory (Path) Traversal is an application vulnerability that allows an attac',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/directory_path_traversal.png',
            name: 'directory_path_traversal',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-22',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#13',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/directory_path_traversal',
        },
        {
            id: 152,
            uuid: '6167f23e8df887fa6176a60d',
            displayName: 'Privileged Interface Exposure',
            description: 'Privileged Interface Exposure is a type of application weakness whereby a privileged (administration) interface is accessible to regular (low-privileged) users of the system. Because administration interfaces are only used by trusted administrator users, they are often overlooked from a security perspective. When exposed to the public Internet a malicious attacker could use the interface to her advantage. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/privileged_interface_exposure.png',
            name: 'privileged_interface_exposure',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A5: Security Misconfiguration ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/privileged_interface_exposure',
        },
        {
            id: 153,
            uuid: '6167f23e2479f15231d557dd',
            displayName: 'Leftover Debug Code',
            description: 'A common development practice is to add back door',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/leftover_debug_code.png',
            name: 'leftover_debug_code',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-489',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/leftover_debug_code',
        },
        {
            id: 154,
            uuid: '6167f23a2479f14e4cd557d1',
            displayName: 'Authentication Credentials In URL',
            description: 'Insecure Logging is a type of application security vulnerability whereby the application is configured to either log sensitive data to log files (such as personally identifiable information, payment card information, or authentication credentials etc). Furthermore, if the application is not correctly validating user-supplied input that is then stored in logs, an attacker is able to maliciously manipulate log files. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/authentication_credentials_in_url.png',
            name: 'authentication_credentials_in_url',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-522',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/authentication_credentials_in_url',
        },
        {
            id: 155,
            uuid: '6167f23f2479f1ecb9d557e0',
            displayName: 'Session Exposure Within URL',
            description: 'The most common flaw is simply not encrypting sensitive data. When crypto is employed, weak key generation and management, and weak algorithm usage is common, particularly weak password hashing techniques. Browser weaknesses are very common and easy to detect, but hard to exploit on a large scale. External attackers have difficulty detecting server side flaws due to limited access and they are also usually hard to exploit. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/session_exposure_within_url.png',
            name: 'session_exposure_within_url',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-613',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/session_exposure_within_url',
        },
        {
            id: 156,
            uuid: '6167f240c27d3d5d85952a07',
            displayName: 'User Enumeration',
            description: 'User Enumeration is a type of application security vulnerability whereby the vulnerable web application reveals whether a username (email address or account name) exists or not, this can be a consequence of a misconfiguration or a design decision. The information obtained via user enumeration can then be used by an attacker to gain a list of users on system. This information can  be used to further attack the web application, for example, such as through a brute force credential guessing attack. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/user_enumeration.png',
            name: 'user_enumeration',
            type: 'system',
            activeOnLean: false,
            isCompleted: true,
            progress: 'completed',
            cwe: 'CWE-203',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: '750',
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/user_enumeration',
        },
        {
            id: 157,
            uuid: '6167f23dc27d3d218a9529fb',
            displayName: 'Horizontal Privilege Escalation',
            description: 'Horizontal Privilege Escalation is an application vulnerability that allows one (normal) User of an application to create, read, update and/or delete the data belonging to another (normal) User. This type of vulnerability is often the result of errors in the authorization logic. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/horizontal_privilege_escalation.png',
            name: 'horizontal_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/horizontal_privilege_escalation',
        },
        {
            id: 158,
            uuid: '6167f2402479f1f94dd557e6',
            displayName: 'Vertical Privilege Escalation',
            description: 'Missing Function Level Access Control is an application vulnerability that allows either an Anonymous User or Legitimate User of the application to access the create, read, update and/or delete functionality belonging to another user of the application. This example we show how Vertical Privilege Escalation is a potential outcome of this vulnerability. Play Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/vertical_privilege_escalation.png',
            name: 'vertical_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/vertical_privilege_escalation',
        },
        {
            id: 159,
            uuid: '6167f23cc27d3db1409529f8',
            displayName: 'Cross Site Request Forgery (POST)',
            description: 'Cross-Site Request Forgery (CSRF) is an application security vulnerability  that pe',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/cross_site_request_forgery_post.png',
            name: 'cross_site_request_forgery_post',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-352',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#12',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/cross_site_request_forgery_post',
        },
        {
            id: 160,
            uuid: '6167f23b8df887b6da76a601',
            displayName: 'Click Jacking',
            description: 'Clickjacking, also known as',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/click_jacking.png',
            name: 'click_jacking',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-451',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/click_jacking',
        },
        {
            id: 161,
            uuid: '6167f23ec27d3d9d679529fe',
            displayName: 'Insecure URL Redirect',
            description: 'Unvalidated redirects and forwards are possible when a web application accepts untrusted input that could cause the web application to redirect the request to a URL contained within untrusted input. By modifying untrusted URL input to a malicious site, an attacker may successfully launch a phishing scam and steal user credentials.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_url_redirect.png',
            name: 'insecure_url_redirect',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-601',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#22',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/insecure_url_redirect',
        },
        {
            id: 162,
            uuid: '6167f23d8df887783976a60a',
            displayName: 'Insecure TLS Validation',
            description: 'Insecure TLS validation is a security vulnerability that permits an attacker to bypass SSL pinning.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_tls_validation.png',
            name: 'insecure_tls_validation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-295',
            owasp: 'A2: Cryptographic Failures',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/insecure_tls_validation',
        },
        {
            id: 163,
            uuid: '6167f23d2479f10114d557da',
            displayName: 'Insecure Object Deserialization',
            description: 'Insecure Object Deserialization is a security vulnerability that permits an attacker to abuse application logic, deny service, or execute arbitrary code, when an object is being deserialized.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_object_deserialization.png',
            name: 'insecure_object_deserialization',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-502',
            owasp: 'A8: Software and Data Integrity Failures',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/insecure_object_deserialization',
        },
        {
            id: 164,
            uuid: '6167f23b2479f1f9d0d557d4',
            displayName: 'Vulnerable and Outdated Components',
            description: 'Code libraries, both proprietary and third-party, need constant maintenance and updates. Even if proprietary code is 100% secure, failure to update third-party components, and particularly updates that mitigate security vulnerabilities, will likely leave environments vulnerable to attack.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/components_with_known_vulnerabilities.png',
            name: 'components_with_known_vulnerabilities',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-1035',
            owasp: 'A6: Vulnerable and Outdated Components ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/components_with_known_vulnerabilities',
        },
        {
            id: 4,
            uuid: '6167f2308df887809a76a5e3',
            displayName: 'SQL Injection',
            description: 'SQL Injection is a type of application security vulnerability whereby a malicious user is able to manipulate the SQL statements that the application sends to the backend database server for execution. A successful SQL injection attack exposes the data of the underlying database directly to the attacker. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            name: 'sql_injection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/sql_injection',
        },
        {
            id: 5,
            uuid: '6167f22c2479f139b4d557a4',
            displayName: 'Command Injection',
            description: 'A Command Injection vulnerability, when exploited by a malicious user, results in execution of arbitrary system commands on the host operating system. Command Injection attacks are possible when an application passes unsafe user supplied data (forms, cookies, HTTP headers, etc) to a system command. The malicious system command is run server side with the same privileges as the application. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/command_injection.png',
            name: 'command_injection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-77',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/command_injection',
        },
        {
            id: 7,
            uuid: '6167f22f2479f1e972d557b3',
            displayName: 'Session Fixation',
            description: 'Session Fixation is a type of application vulnerability where an application does not correctly renew session tokens when changing from a pre-login to post-login state. The same pre-login session token should not be used post-login, otherwise an attacker has the potential to steal authenticated sess',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/session_fixation.png',
            name: 'session_fixation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-384',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/session_fixation',
        },
        {
            id: 6,
            uuid: '6167f2302479f16fd7d557b6',
            displayName: 'Use of Insufficiently Random Values',
            description: 'Insufficiently Random Values are an application security vulnerability whereby the application generates predictable values in sensitive areas of code that absolutely require strict randomness (unpredictability). As a result it may be possible for an attacker to predict the next value generated by the application to defeat cryptographic routines, access sensitive information, or impersonate another user. Play and Learn...\r\n',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/use_of_insufficiently_random_values.png',
            name: 'use_of_insufficiently_random_values',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-330',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/use_of_insufficiently_random_values',
        },
        {
            id: 8,
            uuid: '6167f22f8df887759276a5e0',
            displayName: 'Reflected XSS',
            description: 'Unlike Persistent XSS, with Reflected Cross-site Scripting ',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/reflected_xss.png',
            name: 'reflected_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-79',
            owasp: 'A3: Injection',
            sans: 'SANS-#4',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/reflected_xss',
        },
        {
            id: 9,
            uuid: '6167f230c27d3d714e9529d5',
            displayName: 'Stored (Persistent) XSS',
            description: 'Persistent Cross-Site Scripting (XSS) is an application vulnerability whereby a malicious user tricks a web application into storing attacker-supplied script code which is then later served to unsuspecting user(s) of the application. The attacker-supplied script code runs on the client-side system of other end user(s) of the application. This type of vulnerability is widespread and affects web applications that utilize (unvalidated) user-supplied input to generate (unencoded) application output, that is served to users. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/stored_persistent_xss.png',
            name: 'stored_persistent_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/stored_persistent_xss',
        },
        {
            id: 11,
            uuid: '6167f22d2479f1e989d557aa',
            displayName: 'DOM XSS',
            description: 'Document Object Model (DOM) Based XSS ',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/dom_xss.png',
            name: 'dom_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-79',
            owasp: 'A3: Injection',
            sans: 'SANS-#4',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/dom_xss',
        },
        {
            id: 10,
            uuid: '6167f22d8df887b39c76a5d7',
            displayName: 'Directory (Path) Traversal',
            description: 'Directory (Path) Traversal is an applicatio',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/directory_path_traversal.png',
            name: 'directory_path_traversal',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-22',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#13',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/directory_path_traversal',
        },
        {
            id: 12,
            uuid: '6167f22e2479f1ae30d557b0',
            displayName: 'Privileged Interface Exposure',
            description: 'Privileged Interface Exposure is a type of application weakness whereby a privileged (administration) interface is accessible to regular (low-privileged) users of the system. Because administration interfaces are only used by trusted administrator users, they are often overlooked from a security perspective. When exposed to the public Internet a malicious attacker could use the interface to her advantage. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/privileged_interface_exposure.png',
            name: 'privileged_interface_exposure',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A5: Security Misconfiguration ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/privileged_interface_exposure',
        },
        {
            id: 13,
            uuid: '6167f22ec27d3d4f659529cf',
            displayName: 'Leftover Debug Code',
            description: 'A common development practice is to add back d',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/leftover_debug_code.png',
            name: 'leftover_debug_code',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-489',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/leftover_debug_code',
        },
        {
            id: 14,
            uuid: '6167f22b8df88726d076a5d1',
            displayName: 'Authentication Credentials In URL',
            description: 'Insecure Logging is a type of application security vulnerability whereby the application is configured to either log sensitive data to log files (such as personally identifiable information, payment card information, or authentication credentials etc). Furthermore, if the application is not correctly validating user-supplied input that is then stored in logs, an attacker is able to maliciously manipulate log files. Play and Learn...\r\n\r\n\r\n',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/authentication_credentials_in_url.png',
            name: 'authentication_credentials_in_url',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-522',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/authentication_credentials_in_url',
        },
        {
            id: 15,
            uuid: '6167f22fc27d3d093d9529d2',
            displayName: 'Session Exposure Within URL',
            description: 'The most common flaw is simply not encrypting sensitive data. When crypto is employed, weak key generation and management, and weak algorithm usage is common, particularly weak password hashing techniques. Browser weaknesses are very common and easy to detect, but hard to exploit on a large scale. External attackers have difficulty detecting server side flaws due to limited access and they are also usually hard to exploit. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/session_exposure_within_url.png',
            name: 'session_exposure_within_url',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-613',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/session_exposure_within_url',
        },
        {
            id: 16,
            uuid: '6167f2318df887146076a5e6',
            displayName: 'User Enumeration',
            description: 'User Enumeration is a type of application security vulnerability whereby the vulnerable web application reveals whether a username (email address or account name) exists or not, this can be a consequence of a misconfiguration or a design decision. The information obtained via user enumeration can then be used by an attacker to gain a list of users on system. This information can  be used to further attack the web application, for example, such as through a brute force credential guessing attack. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/user_enumeration.png',
            name: 'user_enumeration',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-203',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/user_enumeration',
        },
        {
            id: 17,
            uuid: '6167f22d8df887214c76a5da',
            displayName: 'Horizontal Privilege Escalation',
            description: 'Horizontal Privilege Escalation is an application vulnerability that allows one (normal) User of an application to create, read, update and/or delete the data belonging to another (normal) User. This type of vulnerability is often the result of errors in the authorization logic. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/horizontal_privilege_escalation.png',
            name: 'horizontal_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/horizontal_privilege_escalation',
        },
        {
            id: 18,
            uuid: '6167f231c27d3d9a1b9529d8',
            displayName: 'Vertical Privilege Escalation',
            description: 'Missing Function Level Access Control is an application vulnerability that allows either an Anonymous User or Legitimate User of the application to access the create, read, update and/or delete functionality belonging to another user of the application. This example we show how Vertical Privilege Escalation is a potential outcome of this vulnerability. Play Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/vertical_privilege_escalation.png',
            name: 'vertical_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/vertical_privilege_escalation',
        },
        {
            id: 20,
            uuid: '6167f22bc27d3de5c39529c7',
            displayName: 'Click Jacking',
            description: 'Clickjacking, also known as a',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/click_jacking.png',
            name: 'click_jacking',
            type: 'system',
            activeOnLean: true,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-451',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/click_jacking',
        },
        {
            id: 21,
            uuid: '6167f22e8df887535876a5dd',
            displayName: 'Insecure URL Redirect',
            description: 'Unvalidated redirects and forwards are possible when a web application accepts untrusted input that could cause the web application to redirect the request to a URL contained within untrusted input. By modifying untrusted URL input to a malicious site, an attacker may successfully launch a phishing scam and steal user credentials.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_url_redirect.png',
            name: 'insecure_url_redirect',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-601',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#22',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/insecure_url_redirect',
        },
        {
            id: 22,
            uuid: '6167f22e2479f12c77d557ad',
            displayName: 'Insecure TLS Validation',
            description: 'Insecure TLS validation is a security vulnerability that permits an attacker to bypass SSL pinning.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_tls_validation.png',
            name: 'insecure_tls_validation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-295',
            owasp: 'A2: Cryptographic Failures',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/insecure_tls_validation',
        },
        {
            id: 23,
            uuid: '6167f22c8df887177e76a5d4',
            displayName: 'Vulnerable and Outdated Components',
            description: 'Code libraries, both proprietary and third-party, need constant maintenance and updates. Even if proprietary code is 100% secure, failure to update third-party components, and particularly updates that mitigate security vulnerabilities, will likely leave environments vulnerable to attack.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/components_with_known_vulnerabilities.png',
            name: 'components_with_known_vulnerabilities',
            type: 'system',
            activeOnLean: true,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-1035',
            owasp: 'A6: Vulnerable and Outdated Components ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/components_with_known_vulnerabilities',
        },
        {
            id: 24,
            uuid: '6167f2152479f1739ad55759',
            displayName: 'Interface Tour',
            description: 'Play me first, before you get started, in order to familiarize yourself with the interactive learning interface components. By completing this very short guide to the interface, we’ll have you moving faster through the learning modules.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_orientation.png',
            name: 'c_orientation',
            type: 'system',
            activeOnLean: false,
            isCompleted: true,
            progress: 'completed',
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: true,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_orientation',
        },
        {
            id: 25,
            uuid: '6167f2158df887312f76a58a',
            displayName: 'Stack Overflows - Primer',
            description: 'Part 1 will introduce concepts we’ll extend upon. This module will give you a brief introduction on how stack data structures are used to keep track of function/subroutines calls, specifically looking at how C/C++ programs save return addresses, parameters and local variables on the stack.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_stack_p1.png',
            name: 'c_stack_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: true,
            progress: 'completed',
            cwe: 'CWE-121',
            owasp: 'A3: Injection',
            sans: 'SANS-#3',
            potentialPoints: 0,
            doneRecently: true,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_stack_p1',
        },
        {
            id: 26,
            uuid: '6167f215c27d3d7c7395297c',
            displayName: 'Stack Overflows',
            description: 'Part 2 will focus on memory corruption of the stack. This module will allow you to interact with insecure code and show how important stack components can be overwritten to alter program flow.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_stack_p2.png',
            name: 'c_stack_p2',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-121',
            owasp: 'A3: Injection',
            sans: 'SANS-#3',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_stack_p2',
        },
        {
            id: 27,
            uuid: '6167f2162479f1670ad5575c',
            displayName: 'Off By One Overflow',
            description: 'An off by one overflow is a type of buffer overflow vulnerability that allows overflowing a buffer by one byte outside the space allocated. The following tutorial will demonstrate an off-by-one overflow vulnerability and presents remediation techniques and solutions to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_stack_p3.png',
            name: 'c_stack_p3',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-193',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_stack_p3',
        },
        {
            id: 28,
            uuid: '6167f213c27d3daf04952976',
            displayName: 'Heap Introduction',
            description: 'The following tutorial will give you a brief introduction on how dynamic memory allocation makes use of the heap, how the malloc family of functions creates and manages chunks of in use, and free, memory. Additionally we will see how memory linked lists are managed via unlink.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_heap_p1.png',
            name: 'c_heap_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-122',
            owasp: 'A3: Injection',
            sans: 'SANS-#20',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_heap_p1',
        },
        {
            id: 29,
            uuid: '6167f2142479f1a117d55756',
            displayName: 'Heap Overflows - Primer',
            description: 'Part 1 will introduce concepts we’ll extend upon. This module will give you a brief introduction on what dynamic memory structures look like, including memory meta data.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_heap_p2.png',
            name: 'c_heap_p2',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-122',
            owasp: 'A3: Injection',
            sans: 'SANS-#20',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_heap_p2',
        },
        {
            id: 30,
            uuid: '6167f2148df88723d476a587',
            displayName: 'Heap Overflows',
            description: 'Part 2 will focus on memory corruption of the heap. This module will allow you to interact with insecure code and show how important heap components can be overwritten, a first step for attackers to execute arbitrary code.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_heap_p3.png',
            name: 'c_heap_p3',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-122',
            owasp: 'A3: Injection',
            sans: 'SANS-#20',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_heap_p3',
        },
        {
            id: 31,
            uuid: '6167f214c27d3deefb952979',
            displayName: 'Integer Overflows - Primer',
            description: 'In this lesson, we will introduce a common insecure design pattern for Integer Overflows. This module will allow you to interact with insecure code and show how Integer Overflows can lead to memory corruption, a first step for attackers to execute arbitrary code.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_integer_p1.png',
            name: 'c_integer_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-190',
            owasp: 'A3: Injection',
            sans: 'SANS-#24',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_integer_p1',
        },
        {
            id: 32,
            uuid: '6167f2132479f1e58cd55750',
            displayName: 'Format String - Primer',
            description: 'Part 1 will focus on refreshing how format strings and format specifiers work at an in-memory level.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_formatstring_p1.png',
            name: 'c_formatstring_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-134',
            owasp: 'A3: Injection',
            sans: 'SANS-#23',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_formatstring_p1',
        },
        {
            id: 33,
            uuid: '6167f213c27d3d0a37952973',
            displayName: 'Format String Attacks',
            description: 'Part 2 will focus on insecure use of format strings and how they can be used by an attacker to read arbitrary values from the program stack',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_formatstring_p2.png',
            name: 'c_formatstring_p2',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-134',
            owasp: 'A3: Injection',
            sans: 'SANS-#23',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_formatstring_p2',
        },
        {
            id: 34,
            uuid: '6167f2132479f1a003d55753',
            displayName: 'Format String Server Attack',
            description: 'In this module, we will exploit a real format string vulnerability present within a remote secure access server. The techniques used for exploitation will help us demonstrate format string vulnerabilities and further present remediation techniques to prevent against such attacks.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_formatstring_p3.png',
            name: 'c_formatstring_p3',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-134',
            owasp: 'A3: Injection',
            sans: 'SANS-#23',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_formatstring_p3',
        },
        {
            id: 35,
            uuid: '6167f2168df88714cc76a58d',
            displayName: 'Clearing Memory',
            description: 'In C/C++ applications, it is often useful to wipe data from memory once it is no longer needed. However, if not performed, applications are exposed to information disclosure vulnerabilities . The following module will cover the basics of how to clear process memory and present techniques and solutions to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/clearing_memory_p1.png',
            name: 'clearing_memory_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-244',
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/clearing_memory_p1',
        },
        {
            id: 36,
            uuid: '6167f2162479f1202ad5575f',
            displayName: 'Dangerous or Insecure Use Of API',
            description: 'The following module will give you a brief introduction o',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/dangerous_use_of_api_p1.png',
            name: 'dangerous_use_of_api_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-749',
            owasp: 'A6: Vulnerable and Outdated Components ',
            sans: 'SANS-#16',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/dangerous_use_of_api_p1',
        },
        {
            id: 37,
            uuid: '6167f216c27d3dbaf195297f',
            displayName: 'Compiler Optimizations Bugs',
            description: 'Compiler optimization issues occur when compliers remove security critical code sections during the code optimization process. The following module will cover the basics of compiler optimization vulnerabilities and present techniques and solutions to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/compiler_optimizations_bugs_p1.png',
            name: 'compiler_optimizations_bugs_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-733',
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/compiler_optimizations_bugs_p1',
        },
        {
            id: 38,
            uuid: '6167f2178df887aed376a590',
            displayName: 'NULL Pointer Dereference',
            description: 'A NULL pointer dereference occurs when the application dereferences a pointer that it expects to be valid, but is NULL, typically causing a crash or exit. The following module explains NULL pointer dereference issues and presents possible techniques and solution to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/null_pointer_dereference_p1.png',
            name: 'null_pointer_dereference_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-476',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/null_pointer_dereference_p1',
        },
        {
            id: 39,
            uuid: '6167f2172479f11a88d55762',
            displayName: 'Race Conditions',
            description: 'Race conditions arise from multiple processes/threads that operate on related entities in an OS that has preemptive scheduling. This module explains race condition issues and their exploits, and presents a few techniques that help avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/race_conditions_p1.png',
            name: 'race_conditions_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-362',
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/race_conditions_p1',
        },
        {
            id: 40,
            uuid: '6167f239c27d3d29c59529ed',
            displayName: 'Forceful Browsing',
            description: 'Forceful (or forced) browsing is a common attack technique used to gain access to web server resources that are restricted, or resources that are accessed outside of the intended (correct) sequence. An attacker carries out the attack by guessing, knowing or inferring the correct URL directly. If the restricted URLs, scripts, or files that reside in the web server directory are not enforced with appropriate authorization or sequencing logic, they can be vulnerable to forceful browsing attacks.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/ios/icons/forceful_browsing.png',
            name: 'forceful_browsing',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-425',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#15',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'iOS',
            url: '/courses/ios/lessons/forceful_browsing',
        },
        {
            id: 41,
            uuid: '6167f2398df88773bd76a5fb',
            displayName: 'Excessive Logging',
            description: 'Excessive logging relates to the storing of information pertaining to the application state within local or remote (in the case of remote crash dumps etc) log files.  When this information contains sensitive data this can present a security risk.  Sensitive information can include: Passwords, personally identifiable information, payment card details, and other (static or temporary) application secrets.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/ios/icons/excessive_logging.png',
            name: 'excessive_logging',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-779',
            owasp: 'A9: Security Logging and Monitoring Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'iOS',
            url: '/courses/ios/lessons/excessive_logging',
        },
        {
            id: 42,
            uuid: '6167f238c27d3d930d9529ea',
            displayName: 'Cached Login Credentials',
            description: 'Cached login credentials are convenient for users because even when they’ve logged out they do not need to re-enter (again) their username and password to authenticate. However they can present an unnecessary security risk, and there are more secure patterns for achieving user convenience.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/ios/icons/cached_login_credentials.png',
            name: 'cached_login_credentials',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-522',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'iOS',
            url: '/courses/ios/lessons/cached_login_credentials',
        },
        {
            id: 43,
            uuid: '6167f23ac27d3d47759529f2',
            displayName: 'Unprotected Background Screenshots',
            description: 'When switching between applications an automatic screenshot of application is taken and cached to allow users to easily identify the status of each running app. In certain scenarios this feature could lead to unintended leakage of sensitive information depending upon the context of the application.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/ios/icons/unprotected_background_screenshots.png',
            name: 'unprotected_background_screenshots',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-522',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'iOS',
            url: '/courses/ios/lessons/unprotected_background_screenshots',
        },
        {
            id: 44,
            uuid: '6167f2388df887854576a5f8',
            displayName: 'Enable Autocomplete Fields',
            description: 'Auto-complete stores completed form field and passwords locally ',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/ios/icons/autocomplete.png',
            name: 'autocomplete',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-522',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'iOS',
            url: '/courses/ios/lessons/autocomplete',
        },
        {
            id: 45,
            uuid: '6167f23a2479f15026d557ce',
            displayName: 'Insecure Local Storage',
            description: 'There are number of patterns for creating, reading, updating and deleting data locally within the iOS. Some approaches are more secure than others. Understand how insecure local data storage can weaken the security of mobile apps.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/ios/icons/insecure_data_storage.png',
            name: 'insecure_data_storage',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-922',
            owasp: 'is it Sensitive Data in File Storage?',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'iOS',
            url: '/courses/ios/lessons/insecure_data_storage',
        },
        {
            id: 46,
            uuid: '6167f23a8df887b8ff76a5fe',
            displayName: 'Sensitive Data in Plist File',
            description: 'Vulnerabilities in the Property List (PList) data store occur when developers assume that users or malware will not have access to the PList file and subsequently store sensitive information in such data-stores on the device. This can typically lead to a security issue, should developers use PList data store for storing sensitive information e.g. Encryption Keys, Hardcoded passwords.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/ios/icons/insecure_data_storage_plist.png',
            name: 'insecure_data_storage_plist',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-922',
            owasp: 'what is this lesson?',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'iOS',
            url: '/courses/ios/lessons/insecure_data_storage_plist',
        },
        {
            id: 47,
            uuid: '6167f2392479f13620d557cb',
            displayName: 'Client Side Injection',
            description: 'Client Side Injection vulnerabilities occur when developers trust external data without validating or sanitizing this input first. This can subsequently lead to security issues, including data leakage or execution of malicious code.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/ios/icons/client_side_injection.png',
            name: 'client_side_injection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            systemCourseDisplayName: 'iOS',
            url: '/courses/ios/lessons/client_side_injection',
        },
    ],
    skillTrees: [],
    learningPaths: [],
};
exports.mockSkillTree = {
    skillTree: [
        {
            uuid: 'f2233483-fc61-4ae9-953a-75ff16905490',
            name: 'Skill Tree scorm',
            description: 'A scorm skill tree',
            duration: 60,
            level: 'basic',
            potentialScore: 10000,
            progress: null,
            createdAt: '2021-11-11T12:00:00.000Z',
        },
        {
            uuid: 'aee03092-8885-438b-84fa-0b89149d1631',
            name: 'Security Champion',
            description: 'Become a Security Champion',
            duration: 342,
            level: 'Expert',
            potentialScore: 4550,
            progress: null,
            createdAt: '2021-10-13T12:00:00.000Z',
        },
        {
            uuid: '84c3c7a2-d4a7-488d-bce4-054d1932e643',
            name: 'Test',
            description: 'Skill Tree with C++',
            duration: 318,
            level: 'basic',
            potentialScore: 22220,
            progress: null,
            createdAt: '2021-10-183T12:00:00.000Z',
        },
    ],
};
exports.mockAssignedContent = {
    courses: [
        {
            id: 20,
            uuid: '14214b4b-15b2-444a-b077-d41b824652cd',
            displayName: 'Android',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            tagline: 'Secure coding in android mobile applications.',
            iconUrl: 'https://content.devcodebashing.com/courses-assets/android.png',
            name: 'android',
            publishedAt: '2020-05-07T17:21:11.000Z',
            activeOnLean: false,
            isPrimary: true,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: 'not_started',
            isSystem: true,
            numberOfLessons: 8,
            nextLessonUrl: '/courses/android/lessons/forceful_browsing',
        },
        {
            id: 21,
            uuid: 'cc94d77d-8d1d-4c63-9a1f-36bf50f0d79d',
            displayName: 'Angular 2+',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            tagline: 'Learn how to secure Angular 2+ web applications.',
            iconUrl: 'https://codebashing-dev-content.s3-eu-west-1.amazonaws.com/courses-assets/angular.svg',
            name: 'angular',
            publishedAt: '2020-06-14T13:07:45.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: 'not_started',
            isSystem: true,
            numberOfLessons: 8,
            nextLessonUrl: '/courses/angular/lessons/anti_xss_mechanism_html_sanitaizer',
        },
        {
            id: 13,
            uuid: '66a71a0b-929d-4872-be0e-54ac775e0cd9',
            displayName: '.NET Advanced',
            description: 'Learn how to secure .NET web applications and practice recognizing different attacks.',
            tagline: 'Practice and learn how to secure .NET web applications.',
            iconUrl: 'https://codebashing-dev-content.s3.eu-west-1.amazonaws.com/courses-assets/NET_Advanced_1_Course_Icon.svg',
            name: 'dotnet_advanced_lessons',
            publishedAt: '2020-05-07T12:12:02.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: 'not_started',
            isSystem: true,
            numberOfLessons: 10,
            nextLessonUrl: '/courses/dotnet_advanced_lessons/lessons/second_order_sql_injection',
        },
        {
            id: 24,
            uuid: '42382720-e474-4765-afdc-536d8d586389',
            displayName: '.NET - API Security',
            description: 'Learn about the OWASP API Security Top 10 - covering all aspects, including the vulnerabilities, why they exist, exploits, and defenses.',
            tagline: 'Learn how to protect against API vulnerabilities.',
            iconUrl: 'https://management.devcodebashing.com/assets/v2/content/courses/dotnet/dotnet-e5236382623b3572dcdb6e99c09ec2dbd2e35ec279d7c3e210dc5fffabb7a74f.png',
            name: 'dotnet_api_security',
            publishedAt: '2020-12-10T16:01:41.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: 'not_started',
            isSystem: true,
            numberOfLessons: 8,
            nextLessonUrl: '/courses/dotnet_api_security/lessons/authentication_credentials_in_url',
        },
        {
            id: 15,
            uuid: '760fc927-9b0d-4832-ac40-35789f9c2f25',
            displayName: '.NET',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            tagline: 'Learn how to secure .NET web applications.',
            iconUrl: 'https://content.codebashing.com/courses-assets/4b48720d-5b79-43db-89e9-cff492f140a5.png',
            name: 'dotnet',
            publishedAt: '2020-05-07T15:27:44.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 1000,
            completionPercentage: 9.09000015258789,
            progress: 'started',
            isSystem: true,
            numberOfLessons: 22,
            nextLessonUrl: '/courses/dotnet/lessons/sql_injection',
        },
        {
            id: 39,
            uuid: '7e2c1b36-c812-4900-af98-c95251a6d7eb',
            displayName: 'testNana change name 2',
            description: 'lesson description',
            tagline: '',
            iconUrl: 'https://content.devcodebashing.com/courses-assets/angular.svg',
            name: 'testnana_change_name_2',
            publishedAt: '2022-07-04T09:34:04.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: null,
            isSystem: true,
            numberOfLessons: 1,
            nextLessonUrl: '/courses/testnana_change_name_2/lessons/demo_lesson',
        },
        {
            id: 37,
            uuid: '11ca0e34-086b-4289-9ad0-7fd3e04fd07f',
            displayName: 'Scala: Backend Security Basics',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits, and defenses.',
            tagline: 'Learn how to secure Scala web applications.',
            iconUrl: 'https://content.codebashing.com/courses-assets/fc338896-dafd-4413-ad28-218249bd9a9d.svg',
            name: 'backend_scala',
            publishedAt: '2022-02-24T07:02:58.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: null,
            isSystem: true,
            numberOfLessons: 19,
            nextLessonUrl: '/courses/backend_scala/lessons/encoding_hashing_encryption',
        },
        {
            id: 228,
            uuid: 'd99f57d5-f774-4d73-ad11-aad1bd3456ff',
            displayName: 'test',
            description: 'test',
            tagline: 'test',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customCourses/customCourse-3.svg',
            name: 'learning_panel_test_1687934649',
            publishedAt: '2023-06-28T06:44:09.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: 'not_started',
            isSystem: false,
            numberOfLessons: 1,
            nextLessonUrl: '/courses/java/lessons/user_enumeration?custom_course_name=learning_panel_test_1687934649',
        },
        {
            id: 226,
            uuid: 'b9c5ed62-4022-4504-ba21-8f0ba315ab9e',
            displayName: 'test-completion',
            description: 'test-completion',
            tagline: 'test-completion',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customCourses/customCourse-4.svg',
            name: 'learning_panel_test_completion_1687844279',
            publishedAt: '2023-06-27T05:37:59.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: null,
            isSystem: false,
            numberOfLessons: 1,
            nextLessonUrl: '/courses/java/lessons/leftover_debug_code?custom_course_name=learning_panel_test_completion_1687844279',
        },
        {
            id: 41,
            uuid: '4df2555f-4592-4135-96ee-d957de5504b9',
            displayName: 'course builder course name edited',
            description: 'course builder desc edited',
            tagline: 'tagline 111111',
            iconUrl: null,
            name: 'course_builder_course_name_edited',
            publishedAt: '2022-08-09T11:49:50.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: null,
            isSystem: true,
            numberOfLessons: 5,
            nextLessonUrl: '/courses/course_builder_course_name_edited/lessons/access_management',
        },
        {
            id: 240,
            uuid: '0e2798f6-8e47-4639-9d4c-082d6ab0bea5',
            displayName: 'CISO test',
            description: 'CISO test',
            tagline: 'CISO test',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customCourses/customCourse-1.svg',
            name: 'learning_panel_ciso_test_1697964062',
            publishedAt: '2023-10-22T08:41:02.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: 'not_started',
            isSystem: false,
            numberOfLessons: 2,
            nextLessonUrl: '/courses/custom_lessons/lessons/ciso_test1697964012?custom_course_name=learning_panel_ciso_test_1697964062',
        },
    ],
    lessons: [
        {
            id: 152,
            uuid: '6167f23e8df887fa6176a60d',
            displayName: 'Privileged Interface Exposure',
            description: 'Privileged Interface Exposure is a type of application weakness whereby a privileged (administration) interface is accessible to regular (low-privileged) users of the system. Because administration interfaces are only used by trusted administrator users, they are often overlooked from a security perspective. When exposed to the public Internet a malicious attacker could use the interface to her advantage. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/privileged_interface_exposure.png',
            name: 'privileged_interface_exposure',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A5: Security Misconfiguration ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/privileged_interface_exposure',
        },
        {
            id: 144,
            uuid: '6167f2408df887dad076a616',
            displayName: 'XXE Processing',
            description: 'XML External Entity (XXE) Processing is a type of application security vulnerability whereby a malicious user can attack poorly configured/implemented XML parser within an application. Malicious external entity references can be forced by an attacker, which results in unauthorized read-access to sensitive files on the server that the XML parser runs from. Denial of Service is another potential outcome. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/xxe_processing.png',
            name: 'xxe_processing',
            type: 'system',
            activeOnLean: true,
            isCompleted: true,
            progress: 'completed',
            cwe: 'CWE-611',
            owasp: 'A5: Security Misconfiguration ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: '500',
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/xxe_processing',
        },
        {
            id: 153,
            uuid: '6167f23e2479f15231d557dd',
            displayName: 'Leftover Debug Code',
            description: 'A common development practice is to add back door code specifically designed for debugging or testing purposes that is not intended to be shipped or deployed with the application. When this sort of debug code is accidentally left in the application',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/leftover_debug_code.png',
            name: 'leftover_debug_code',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-489',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/leftover_debug_code',
        },
        {
            id: 157,
            uuid: '6167f23dc27d3d218a9529fb',
            displayName: 'Horizontal Privilege Escalation',
            description: 'Horizontal Privilege Escalation is an application vulnerability that allows one (normal) User of an application to create, read, update and/or delete the data belonging to another (normal) User. This type of vulnerability is often the result of errors in the authorization logic. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/horizontal_privilege_escalation.png',
            name: 'horizontal_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/horizontal_privilege_escalation',
        },
        {
            id: 159,
            uuid: '6167f23cc27d3db1409529f8',
            displayName: 'Cross Site Request Forgery (POST)',
            description: 'Cross-Site Request Forgery (CSRF) is an application security vulnerability  that permits an attacker to force another logged-in user of the application to perform actions within that application without realising. The classic example is Bob and Alice both being logged-in users of an online banking application, and Bob tricks Alice into making a funds transfer to Bobs account with CSRF. Importantly, in CSRF attacks the attacker does not have a direct mechanism for seeing the applications response to the victim. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/cross_site_request_forgery_post.png',
            name: 'cross_site_request_forgery_post',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-352',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#12',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/cross_site_request_forgery_post',
        },
        {
            id: 155,
            uuid: '6167f23f2479f1ecb9d557e0',
            displayName: 'Session Exposure Within URL',
            description: 'The most common flaw is simply not encrypting sensitive data. When crypto is employed, weak key generation and management, and weak algorithm usage is common, particularly weak password hashing techniques. Browser weaknesses are very common and easy to detect, but hard to exploit on a large scale. External attackers have difficulty detecting server side flaws due to limited access and they are also usually hard to exploit. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/session_exposure_within_url.png',
            name: 'session_exposure_within_url',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-613',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/session_exposure_within_url',
        },
        {
            id: 158,
            uuid: '6167f2402479f1f94dd557e6',
            displayName: 'Vertical Privilege Escalation',
            description: 'Missing Function Level Access Control is an application vulnerability that allows either an Anonymous User or Legitimate User of the application to access the create, read, update and/or delete functionality belonging to another user of the application. This example we show how Vertical Privilege Escalation is a potential outcome of this vulnerability. Play Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/vertical_privilege_escalation.png',
            name: 'vertical_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/vertical_privilege_escalation',
        },
        {
            id: 150,
            uuid: '6167f23c8df887633876a607',
            displayName: 'DOM XSS',
            description: 'Document Object Model (DOM) Based XSS is a type of XSS attack wherein the attackers payload is executed as a result of modifying the DOM âenvironmentâ in the victimâs browser used by the original client side script, so that the client side code runs in an âunexpectedâ manner. That is, the page itself (the HTTP response that is) does not change, but the client side code contained in the page executes differently due to the malicious modifications that have occurred in the DOM environment. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/dom_xss.png',
            name: 'dom_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-79',
            owasp: 'A3: Injection',
            sans: 'SANS-#4',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/dom_xss',
        },
        {
            id: 149,
            uuid: '6167f23f2479f1d557d557e3',
            displayName: 'Stored (Persistent) XSS',
            description: 'Persistent Cross-Site Scripting (XSS) is an application vulnerability whereby a malicious user tricks a web application into storing attacker-supplied script code which is then later served to unsuspecting user(s) of the application. The attacker-supplied script code runs on the client-side system of other end user(s) of the application. This type of vulnerability is widespread and affects web applications that utilize (unvalidated) user-supplied input to generate (unencoded) application output, that is served to users. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/stored_persistent_xss.png',
            name: 'stored_persistent_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/stored_persistent_xss',
        },
        {
            id: 11,
            uuid: '6167f22d2479f1e989d557aa',
            displayName: 'DOM XSS',
            description: 'Document Object Model (DOM) Based XSS is a type of XSS attack wherein the attackers payload is executed as a result of modifying the DOM âenvironmentâ in the victimâs browser used by the original client side script, so that the client side code runs in an âunexpectedâ manner. That is, the page itself (the HTTP response that is) does not change, but the client side code contained in the page executes differently due to the malicious modifications that have occurred in the DOM environment. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/dom_xss.png',
            name: 'dom_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-79',
            owasp: 'A3: Injection',
            sans: 'SANS-#4',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/dom_xss',
        },
        {
            id: 164,
            uuid: '6167f23b2479f1f9d0d557d4',
            displayName: 'Vulnerable and Outdated Components',
            description: 'Code libraries, both proprietary and third-party, need constant maintenance and updates. Even if proprietary code is 100% secure, failure to update third-party components, and particularly updates that mitigate security vulnerabilities, will likely leave environments vulnerable to attack.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/components_with_known_vulnerabilities.png',
            name: 'components_with_known_vulnerabilities',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-1035',
            owasp: 'A6: Vulnerable and Outdated Components ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/components_with_known_vulnerabilities',
        },
        {
            id: 163,
            uuid: '6167f23d2479f10114d557da',
            displayName: 'Insecure Object Deserialization',
            description: 'Insecure Object Deserialization is a security vulnerability that permits an attacker to abuse application logic, deny service, or execute arbitrary code, when an object is being deserialized.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_object_deserialization.png',
            name: 'insecure_object_deserialization',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-502',
            owasp: 'A8: Software and Data Integrity Failures',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/insecure_object_deserialization',
        },
        {
            id: 9,
            uuid: '6167f230c27d3d714e9529d5',
            displayName: 'Stored (Persistent) XSS',
            description: 'Persistent Cross-Site Scripting (XSS) is an application vulnerability whereby a malicious user tricks a web application into storing attacker-supplied script code which is then later served to unsuspecting user(s) of the application. The attacker-supplied script code runs on the client-side system of other end user(s) of the application. This type of vulnerability is widespread and affects web applications that utilize (unvalidated) user-supplied input to generate (unencoded) application output, that is served to users. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/stored_persistent_xss.png',
            name: 'stored_persistent_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/stored_persistent_xss',
        },
        {
            id: 5,
            uuid: '6167f22c2479f139b4d557a4',
            displayName: 'Command Injection',
            description: 'A Command Injection vulnerability, when exploited by a malicious user, results in execution of arbitrary system commands on the host operating system. Command Injection attacks are possible when an application passes unsafe user supplied data (forms, cookies, HTTP headers, etc) to a system command. The malicious system command is run server side with the same privileges as the application. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/command_injection.png',
            name: 'command_injection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-77',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/command_injection',
        },
        {
            id: 12,
            uuid: '6167f22e2479f1ae30d557b0',
            displayName: 'Privileged Interface Exposure',
            description: 'Privileged Interface Exposure is a type of application weakness whereby a privileged (administration) interface is accessible to regular (low-privileged) users of the system. Because administration interfaces are only used by trusted administrator users, they are often overlooked from a security perspective. When exposed to the public Internet a malicious attacker could use the interface to her advantage. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/privileged_interface_exposure.png',
            name: 'privileged_interface_exposure',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A5: Security Misconfiguration ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/privileged_interface_exposure',
        },
        {
            id: 15,
            uuid: '6167f22fc27d3d093d9529d2',
            displayName: 'Session Exposure Within URL',
            description: 'The most common flaw is simply not encrypting sensitive data. When crypto is employed, weak key generation and management, and weak algorithm usage is common, particularly weak password hashing techniques. Browser weaknesses are very common and easy to detect, but hard to exploit on a large scale. External attackers have difficulty detecting server side flaws due to limited access and they are also usually hard to exploit. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/session_exposure_within_url.png',
            name: 'session_exposure_within_url',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-613',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/session_exposure_within_url',
        },
        {
            id: 6,
            uuid: '6167f2302479f16fd7d557b6',
            displayName: 'Use of Insufficiently Random Values',
            description: 'Insufficiently Random Values are an application security vulnerability whereby the application generates predictable values in sensitive areas of code that absolutely require strict randomness (unpredictability). As a result it may be possible for an attacker to predict the next value generated by the application to defeat cryptographic routines, access sensitive information, or impersonate another user. Play and Learn...\r\n',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/use_of_insufficiently_random_values.png',
            name: 'use_of_insufficiently_random_values',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-330',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/use_of_insufficiently_random_values',
        },
        {
            id: 4,
            uuid: '6167f2308df887809a76a5e3',
            displayName: 'SQL Injection',
            description: 'SQL Injection is a type of application security vulnerability whereby a malicious user is able to manipulate the SQL statements that the application sends to the backend database server for execution. A successful SQL injection attack exposes the data of the underlying database directly to the attacker. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            name: 'sql_injection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/sql_injection',
        },
        {
            id: 14,
            uuid: '6167f22b8df88726d076a5d1',
            displayName: 'Authentication Credentials In URL',
            description: 'Insecure Logging is a type of application security vulnerability whereby the application is configured to either log sensitive data to log files (such as personally identifiable information, payment card information, or authentication credentials etc). Furthermore, if the application is not correctly validating user-supplied input that is then stored in logs, an attacker is able to maliciously manipulate log files. Play and Learn...\r\n\r\n\r\n',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/authentication_credentials_in_url.png',
            name: 'authentication_credentials_in_url',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-522',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/authentication_credentials_in_url',
        },
        {
            id: 13,
            uuid: '6167f22ec27d3d4f659529cf',
            displayName: 'Leftover Debug Code',
            description: 'A common development practice is to add back door code specifically designed for debugging or testing purposes that is not intended to be shipped or deployed with the application. When this sort of debug code is accidentally left in the application',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/leftover_debug_code.png',
            name: 'leftover_debug_code',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-489',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/leftover_debug_code',
        },
        {
            id: 16,
            uuid: '6167f2318df887146076a5e6',
            displayName: 'User Enumeration',
            description: 'User Enumeration is a type of application security vulnerability whereby the vulnerable web application reveals whether a username (email address or account name) exists or not, this can be a consequence of a misconfiguration or a design decision. The information obtained via user enumeration can then be used by an attacker to gain a list of users on system. This information can  be used to further attack the web application, for example, such as through a brute force credential guessing attack. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/user_enumeration.png',
            name: 'user_enumeration',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-203',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/user_enumeration',
        },
        {
            id: 17,
            uuid: '6167f22d8df887214c76a5da',
            displayName: 'Horizontal Privilege Escalation',
            description: 'Horizontal Privilege Escalation is an application vulnerability that allows one (normal) User of an application to create, read, update and/or delete the data belonging to another (normal) User. This type of vulnerability is often the result of errors in the authorization logic. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/horizontal_privilege_escalation.png',
            name: 'horizontal_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/horizontal_privilege_escalation',
        },
        {
            id: 7,
            uuid: '6167f22f2479f1e972d557b3',
            displayName: 'Session Fixation',
            description: 'Session Fixation is a type of application vulnerability where an application does not correctly renew session tokens when changing from a pre-login to post-login state. The same pre-login session token should not be used post-login, otherwise an attacker has the potential to steal authenticated sessions of legitimate users. When a session of one user is stolen by another, it is known as a hijacked session. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/session_fixation.png',
            name: 'session_fixation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-384',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/session_fixation',
        },
        {
            id: 10,
            uuid: '6167f22d8df887b39c76a5d7',
            displayName: 'Directory (Path) Traversal',
            description: 'Directory (Path) Traversal is an application vulnerability that allows an attacker to access directories and  files that are stored outside the web root folder. This type of vulnerability is found in applications that make insecure references to files based on user supplied input. A classic example is manipulating file location input variables with “dot-dot-slash (../)” sequences and its variations, to access arbitrary files and directories of the servers file system, such as sourcecode or password files, or other sensitive files. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/directory_path_traversal.png',
            name: 'directory_path_traversal',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-22',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#13',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/directory_path_traversal',
        },
        {
            id: 21,
            uuid: '6167f22e8df887535876a5dd',
            displayName: 'Insecure URL Redirect',
            description: 'Unvalidated redirects and forwards are possible when a web application accepts untrusted input that could cause the web application to redirect the request to a URL contained within untrusted input. By modifying untrusted URL input to a malicious site, an attacker may successfully launch a phishing scam and steal user credentials.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_url_redirect.png',
            name: 'insecure_url_redirect',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-601',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#22',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/insecure_url_redirect',
        },
        {
            id: 22,
            uuid: '6167f22e2479f12c77d557ad',
            displayName: 'Insecure TLS Validation',
            description: 'Insecure TLS validation is a security vulnerability that permits an attacker to bypass SSL pinning.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_tls_validation.png',
            name: 'insecure_tls_validation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-295',
            owasp: 'A2: Cryptographic Failures',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/insecure_tls_validation',
        },
        {
            id: 23,
            uuid: '6167f22c8df887177e76a5d4',
            displayName: 'Vulnerable and Outdated Components',
            description: 'Code libraries, both proprietary and third-party, need constant maintenance and updates. Even if proprietary code is 100% secure, failure to update third-party components, and particularly updates that mitigate security vulnerabilities, will likely leave environments vulnerable to attack.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/components_with_known_vulnerabilities.png',
            name: 'components_with_known_vulnerabilities',
            type: 'system',
            activeOnLean: true,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-1035',
            owasp: 'A6: Vulnerable and Outdated Components ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/components_with_known_vulnerabilities',
        },
        {
            id: 25,
            uuid: '6167f2158df887312f76a58a',
            displayName: 'Stack Overflows - Primer',
            description: 'Part 1 will introduce concepts we’ll extend upon. This module will give you a brief introduction on how stack data structures are used to keep track of function/subroutines calls, specifically looking at how C/C++ programs save return addresses, parameters and local variables on the stack.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_stack_p1.png',
            name: 'c_stack_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-121',
            owasp: 'A3: Injection',
            sans: 'SANS-#3',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_stack_p1',
        },
        {
            id: 26,
            uuid: '6167f215c27d3d7c7395297c',
            displayName: 'Stack Overflows',
            description: 'Part 2 will focus on memory corruption of the stack. This module will allow you to interact with insecure code and show how important stack components can be overwritten to alter program flow.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_stack_p2.png',
            name: 'c_stack_p2',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-121',
            owasp: 'A3: Injection',
            sans: 'SANS-#3',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_stack_p2',
        },
        {
            id: 27,
            uuid: '6167f2162479f1670ad5575c',
            displayName: 'Off By One Overflow',
            description: 'An off by one overflow is a type of buffer overflow vulnerability that allows overflowing a buffer by one byte outside the space allocated. The following tutorial will demonstrate an off-by-one overflow vulnerability and presents remediation techniques and solutions to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_stack_p3.png',
            name: 'c_stack_p3',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-193',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_stack_p3',
        },
        {
            id: 20,
            uuid: '6167f22bc27d3de5c39529c7',
            displayName: 'Click Jacking',
            description: 'Clickjacking, also known as a UI redress attack, is when an attacker uses multiple transparent or opaque layers to trick a user into clicking on a button or link on another page when they were intending to click on the the top level page. Thus, the attacker is hijacking clicks meant for their page and routing them to another page, most likely owned by another application, domain, or both.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/click_jacking.png',
            name: 'click_jacking',
            type: 'system',
            activeOnLean: true,
            isCompleted: true,
            progress: 'completed',
            cwe: 'CWE-451',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: '1000',
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/click_jacking',
        },
        {
            id: 35,
            uuid: '6167f2168df88714cc76a58d',
            displayName: 'Clearing Memory',
            description: 'In C/C++ applications, it is often useful to wipe data from memory once it is no longer needed. However, if not performed, applications are exposed to information disclosure vulnerabilities . The following module will cover the basics of how to clear process memory and present techniques and solutions to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/clearing_memory_p1.png',
            name: 'clearing_memory_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-244',
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/clearing_memory_p1',
        },
        {
            id: 18,
            uuid: '6167f231c27d3d9a1b9529d8',
            displayName: 'Vertical Privilege Escalation',
            description: 'Missing Function Level Access Control is an application vulnerability that allows either an Anonymous User or Legitimate User of the application to access the create, read, update and/or delete functionality belonging to another user of the application. This example we show how Vertical Privilege Escalation is a potential outcome of this vulnerability. Play Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/vertical_privilege_escalation.png',
            name: 'vertical_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/vertical_privilege_escalation',
        },
        {
            id: 28,
            uuid: '6167f213c27d3daf04952976',
            displayName: 'Heap Introduction',
            description: 'The following tutorial will give you a brief introduction on how dynamic memory allocation makes use of the heap, how the malloc family of functions creates and manages chunks of in use, and free, memory. Additionally we will see how memory linked lists are managed via unlink.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_heap_p1.png',
            name: 'c_heap_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-122',
            owasp: 'A3: Injection',
            sans: 'SANS-#20',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_heap_p1',
        },
        {
            id: 32,
            uuid: '6167f2132479f1e58cd55750',
            displayName: 'Format String - Primer',
            description: 'Part 1 will focus on refreshing how format strings and format specifiers work at an in-memory level.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_formatstring_p1.png',
            name: 'c_formatstring_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-134',
            owasp: 'A3: Injection',
            sans: 'SANS-#23',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_formatstring_p1',
        },
        {
            id: 30,
            uuid: '6167f2148df88723d476a587',
            displayName: 'Heap Overflows',
            description: 'Part 2 will focus on memory corruption of the heap. This module will allow you to interact with insecure code and show how important heap components can be overwritten, a first step for attackers to execute arbitrary code.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_heap_p3.png',
            name: 'c_heap_p3',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-122',
            owasp: 'A3: Injection',
            sans: 'SANS-#20',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_heap_p3',
        },
        {
            id: 34,
            uuid: '6167f2132479f1a003d55753',
            displayName: 'Format String Server Attack',
            description: 'In this module, we will exploit a real format string vulnerability present within a remote secure access server. The techniques used for exploitation will help us demonstrate format string vulnerabilities and further present remediation techniques to prevent against such attacks.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_formatstring_p3.png',
            name: 'c_formatstring_p3',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-134',
            owasp: 'A3: Injection',
            sans: 'SANS-#23',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_formatstring_p3',
        },
        {
            id: 37,
            uuid: '6167f216c27d3dbaf195297f',
            displayName: 'Compiler Optimizations Bugs',
            description: 'Compiler optimization issues occur when compliers remove security critical code sections during the code optimization process. The following module will cover the basics of compiler optimization vulnerabilities and present techniques and solutions to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/compiler_optimizations_bugs_p1.png',
            name: 'compiler_optimizations_bugs_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-733',
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/compiler_optimizations_bugs_p1',
        },
        {
            id: 29,
            uuid: '6167f2142479f1a117d55756',
            displayName: 'Heap Overflows - Primer',
            description: 'Part 1 will introduce concepts we’ll extend upon. This module will give you a brief introduction on what dynamic memory structures look like, including memory meta data.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_heap_p2.png',
            name: 'c_heap_p2',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-122',
            owasp: 'A3: Injection',
            sans: 'SANS-#20',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_heap_p2',
        },
        {
            id: 39,
            uuid: '6167f2172479f11a88d55762',
            displayName: 'Race Conditions',
            description: 'Race conditions arise from multiple processes/threads that operate on related entities in an OS that has preemptive scheduling. This module explains race condition issues and their exploits, and presents a few techniques that help avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/race_conditions_p1.png',
            name: 'race_conditions_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-362',
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/race_conditions_p1',
        },
        {
            id: 31,
            uuid: '6167f214c27d3deefb952979',
            displayName: 'Integer Overflows - Primer',
            description: 'In this lesson, we will introduce a common insecure design pattern for Integer Overflows. This module will allow you to interact with insecure code and show how Integer Overflows can lead to memory corruption, a first step for attackers to execute arbitrary code.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_integer_p1.png',
            name: 'c_integer_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-190',
            owasp: 'A3: Injection',
            sans: 'SANS-#24',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_integer_p1',
        },
        {
            id: 36,
            uuid: '6167f2162479f1202ad5575f',
            displayName: 'Dangerous or Insecure Use Of API',
            description: 'The following module will give you a brief introduction on how common APIs if implemented incorrectly can cause side effects that a malicious user can exploit to cause unexpected behavior, such as execution of unauthorized commands. We will also see the  possible techniques and solution to avoiding such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/dangerous_use_of_api_p1.png',
            name: 'dangerous_use_of_api_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-749',
            owasp: 'A6: Vulnerable and Outdated Components ',
            sans: 'SANS-#16',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/dangerous_use_of_api_p1',
        },
        {
            id: 33,
            uuid: '6167f213c27d3d0a37952973',
            displayName: 'Format String Attacks',
            description: 'Part 2 will focus on insecure use of format strings and how they can be used by an attacker to read arbitrary values from the program stack',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_formatstring_p2.png',
            name: 'c_formatstring_p2',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-134',
            owasp: 'A3: Injection',
            sans: 'SANS-#23',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_formatstring_p2',
        },
        {
            id: 38,
            uuid: '6167f2178df887aed376a590',
            displayName: 'NULL Pointer Dereference',
            description: 'A NULL pointer dereference occurs when the application dereferences a pointer that it expects to be valid, but is NULL, typically causing a crash or exit. The following module explains NULL pointer dereference issues and presents possible techniques and solution to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/null_pointer_dereference_p1.png',
            name: 'null_pointer_dereference_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-476',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/null_pointer_dereference_p1',
        },
        {
            id: 627,
            uuid: '7f1043d4-fab7-445b-ab47-c35e771f7a25',
            displayName: 'CISO test 2',
            description: 'CISO test 2',
            duration: '',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customLessons/customLesson-1.svg',
            name: 'ciso_test_21698172743',
            type: 'custom',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: null,
            url: '/courses/custom_lessons/lessons/ciso_test_21698172743',
        },
        {
            id: 621,
            uuid: '66fc9fed-2c97-43b4-a93f-f75c4f1f525a',
            displayName: 'CISO Test',
            description: 'dfdf',
            duration: '',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customLessons/customLesson-1.svg',
            name: 'ciso_test1697964012',
            type: 'custom',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: null,
            url: '/courses/custom_lessons/lessons/ciso_test1697964012',
        },
        {
            id: 587,
            uuid: '64915539f2c6b8701f4740c7',
            displayName: 'Unrestricted Resource Consumption',
            description: "This lesson covers Unrestricted Resource Consumption, formerly Lack of Resources and Rate Limiting (OWASP API4: 2019). We will discuss potential vulnerabilities in APIs  that don't restrict the number or size of resources a client requests, the potential impact of such attacks, their detection and exploitation, and their preventative actions.",
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/add13ee3-0987-47cc-a401-a489f6e62d05.svg',
            name: 'unrestricted_resource_consumption',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/unrestricted_resource_consumption',
        },
        {
            id: 586,
            uuid: '649d851f20007b3700e91749',
            displayName: 'Broken Object Property Level Authorization - Excessive data exposure',
            description: 'In the next lesson, you will learn about: “Broken Object Property Level Authorization,”  formerly the “Excessive Data Exposure” vulnerability (OWASP API3: 2019).  \nIt occurs when developers expose too much data to the client in their response.  You will understand how to detect it, the potential impacts of such an issue,  and its standard remediation methods.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/b1f68356-d43d-40e7-bcda-a7a79531a6fd.svg',
            name: 'broken_object_property_level_authorization',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/broken_object_property_level_authorization',
        },
        {
            id: 592,
            uuid: '64a1946981b81940e3da5094',
            displayName: 'Improper Inventory Management',
            description: 'This lesson covers “Improper Inventory Management,” \nformerly “Improper Asset Management” (OWASP API9: 2019). \nIt focuses on potential vulnerabilities that arise from poorly tracked, \nmonitored or secured API digital resources, their potential impact, \nand their detection, exploitation, and preventative actions.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/b948de38-baa5-49e5-ae50-f58f0e302bb9.svg',
            name: 'improper_inventory_management',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/improper_inventory_management',
        },
        {
            id: 588,
            uuid: '64a2816820007be388e9ada7',
            displayName: 'Security Misconfiguration',
            description: 'Learn how “Security Misconfigurations” can put your API at risk at any level, \nfrom the network to the application. \nTo ensure you’re fully aware of the important API security factors, \nwe’ll dive into specific aspects of each component, \nlike web servers, databases, and monitoring systems. \nBy exploring these components, you’ll become a pro \nand have a strong grasp of their security. \nDon’t worry; we’ll guide you through it all!',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/364d2e74-d1e8-49e0-a8c1-91d9e474f7ef.svg',
            name: 'security_misconfiguration',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/security_misconfiguration',
        },
        {
            id: 591,
            uuid: '64a28254b51cd275f18121c0',
            displayName: 'Insufficient Logging and Monitoring',
            description: 'In this lesson, you will learn about an important aspect of API security: \n“Insufficient Logging and Monitoring”. \nAttackers always look for vulnerabilities to exploit; \nIf insufficient logging and monitoring are in place, they can go undetected. \nTherefore, it is crucial to understand this aspect of API security \nand take proactive measures to protect your digital assets. \nSo, let’s dive in and explore how APIs must monitor and log events.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/9016f071-a891-43bd-bca5-4fc32820e964.svg',
            name: 'insufficient_logging_and_monitoring',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/insufficient_logging_and_monitoring',
        },
        {
            id: 590,
            uuid: '64a2827f81b8195e18da5ec0',
            displayName: 'Expression Language Injection',
            description: 'This lesson will explore the growing threat of “EL Injection.”\nAttackers can exploit EL Injection to access sensitive data and compromise your systems. \nHowever, with the proper knowledge, \nyou can defend yourself and prevent these attacks from succeeding. \nLet’s delve into EL Injection and learn how to protect yourself \nand your community from this dangerous vulnerability.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/475bd99e-e85c-4403-9fd7-55a83510f2df.svg',
            name: 'expression_language_injection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/expression_language_injection',
        },
        {
            id: 595,
            uuid: '64abe5fbb51cd23955827d90',
            displayName: ' Command Injections',
            description: 'In this lesson, you will learn about Command Injections.n\nHow a Command Injection attack is used to compromise the security of a back-end application nand how to write code more securely to protect against \nthese attacks.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/686d4516-c768-49e3-8e00-5ef9589eadff.svg',
            name: 'command_injections',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/command_injections',
        },
        {
            id: 600,
            uuid: '64abe6eeb51cd2ae75827ddc',
            displayName: 'Lack of Automated  Threat Protection',
            description: 'Automated threats are everywhere, \nand the chance of encountering one in APIs is \nsignificantly high!\n\nBe conscious of the various automated attacks out there, learn how to detect them, and prevent potential harm to your API. ',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/a1b3ef3e-7482-490e-8c83-c0b0dc657e62.svg',
            name: 'lack_of_automated_threat_protection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/lack_of_automated_threat_protection',
        },
        {
            id: 601,
            uuid: '64ae8ed6b51cd23f65831604',
            displayName: 'Broken Object Property Level Authorization - Mass Assignment',
            description: 'We have already covered Broken object property level authorization\nregarding excessive data exposure.  \nThis lesson covers “Mass Assignment” (OWASP API6:2019). \nIts definition, risks, impacts, how to detect and remediate it \nso APIs won’t be affected anymore, and so much more. \nBuckle up and brace yourself!',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/3d3157cc-d255-4056-8548-faad20d79445.svg',
            name: 'broken_object_property_level_authorization_mass_assignment',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/broken_object_property_level_authorization_mass_assignment',
        },
        {
            id: 384,
            uuid: '6167f2022479f1807bd5571d',
            displayName: ' Sensitive Data Exposure',
            description: 'Sensitive data, such as personally identifiable information, business secrets, and sensitive system information, must be protected from unauthorized access. Failure to do so can lead to data breaches, data thefts, business disruption, and even legal penalties. It is best to employ appropriate security controls for protecting the data being used by the application. Play and learn...',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/sensitive_data_exposure.svg',
            name: 'sensitive_data_exposure',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-540',
            owasp: 'A2: Cryptographic Failures',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Application Security for Decision Makers',
            url: '/courses/application_security_for_decision_makers/lessons/sensitive_data_exposure',
        },
        {
            id: 382,
            uuid: '6167f1ffc27d3df88a952935',
            displayName: ' Identification and Authentication Failures',
            description: 'Broken authentication is a security vulnerability caused due to faulty credential management and session management functionalities. An attacker can exploit the vulnerability by bypassing the authentication mechanism or stealing the session ID to gain unauthorized access to users accounts or other sensitive information. Play and learn...',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/broken_authentication.svg',
            name: 'broken_authentication',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-1028',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Application Security for Decision Makers',
            url: '/courses/application_security_for_decision_makers/lessons/broken_authentication',
        },
        {
            id: 120,
            uuid: '6167f207c27d3da0e395294a',
            displayName: ' Command Injection',
            description: 'A Command Injection vulnerability results in the execution of arbitrary system commands on the host operating system. Command Injection attacks are possible when an application passes unsafe user-supplied data (forms, cookies, HTTP headers, etc.) to a system command. The malicious system command is run server-side with the same privileges as the application. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/command_injection.png',
            name: 'command_injection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-77',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: '.NET: Backend Security Basics',
            url: '/courses/backend_dotnet/lessons/command_injection',
        },
        {
            id: 634,
            uuid: '65686076aeeb49a4225e052b',
            displayName: 'Access to Docker Registry',
            description: 'In this lesson, we will dive into the crucial role that image registries play within Docker infrastructure. \nWe will touch upon the potential security implications of unauthorized access to Docker registries and provide insights into how to detect, prevent, and remediate such vulnerabilities. ',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/b4951713-cc5f-4aff-97d0-2f3f8e20122d.svg',
            name: 'access_to_docker_registry',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Docker',
            url: '/courses/docker/lessons/access_to_docker_registry',
        },
        {
            id: 441,
            uuid: '61c43c8cf381131fc9513e57',
            displayName: 'Access Management',
            description: 'Access management for object storage is complex and full of nuances. Misconfiguration of these settings can lead to different security issues, such as sensitive data exposure. Preventing this requires knowledge of the different kinds of access settings and the interactions between them. Play and Learn…',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/6cdafe35-57fb-41d8-ab45-d1575093a1b3.svg',
            name: 'access_management',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'course builder course name edited',
            url: '/courses/course_builder_course_name_edited/lessons/access_management',
        },
        {
            id: 390,
            uuid: '6167f2038df887724776a557',
            displayName: ' Identification and Authentication Failures',
            description: 'Broken authentication is a security vulnerability caused due to faulty credential management and session management functionalities. An attacker can exploit the vulnerability by bypassing the authentication mechanism or stealing the session ID to gain unauthorized access to users accounts or other sensitive information. Play and learn...',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/broken_authentication.svg',
            name: 'broken_authentication',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-1028',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Application Security for QA',
            url: '/courses/application_security_for_qa/lessons/broken_authentication',
        },
        {
            id: 82,
            uuid: '6167f271c27d3d571b952aab',
            displayName: 'Apex',
            description: 'Source codes is a library exposing vulnerable code and its remediated counter part. Skim through the dozens of different vulnerabilities according to your framework of choice. Review, learn and remediate your code faster.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/apex.png',
            name: 'apex',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Source Code',
            url: '/courses/source_codes/lessons/apex',
        },
    ],
    skillTrees: [
        {
            name: 'Test',
            description: 'Skill Tree with C++',
            level: 'basic',
            duration: 318,
            createdAt: '2023-10-20T07:14:53.000Z',
            percent: 0,
            status: 'not_started',
            dueDate: null,
        },
        {
            name: 'Skill Tree with C++',
            description: 'Skill Tree with C++',
            level: 'basic',
            duration: 12,
            createdAt: '2023-10-17T10:40:27.000Z',
            percent: 0,
            status: 'not_started',
            dueDate: '2024-03-01T22:00:00.000Z',
        },
        {
            name: 'Security Champion',
            description: 'Become a Security Champion',
            level: 'Advanced',
            duration: 474,
            createdAt: '2023-10-08T16:52:00.000Z',
            percent: 0,
            status: 'started',
            dueDate: '2024-03-28T22:00:00.000Z',
        },
    ],
    learningPaths: [
        {
            name: 'check scorm player 111',
            description: 'A learning path for checking the scorm lessons 111',
            level: 'basic',
            duration: 60,
            createdAt: '2023-10-25T08:29:27.000Z',
            percent: 0,
            status: 'not_started',
            dueDate: '2024-01-28T22:00:00.000Z',
        },
        {
            name: 'Disney Learning Path Celebration!',
            description: 'Disney Learning Path Celebration',
            level: 'basic',
            duration: 160,
            createdAt: '2024-02-28T11:25:10.000Z',
            percent: 0,
            status: 'not_started',
            dueDate: '2024-01-30T22:00:00.000Z',
        },
    ],
};
exports.mockeRecentlyAddedContent = {
    courses: exports.mockCourses.courses,
    videoTutorials: videoTutorialApi_1.mockVideoTutorialData.slice(0, 5),
    skillTrees: exports.mockSkillTree.skillTree,
    lessons: exports.mockLessons.lessons,
    learningPaths: learningPathsApi_1.mockLearningPaths,
};
exports.mockLeanContent = {
    courses: [
        {
            id: 20,
            uuid: '14214b4b-15b2-444a-b077-d41b824652cd',
            displayName: 'Android',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            tagline: 'Secure coding in android mobile applications.',
            iconUrl: 'https://content.devcodebashing.com/courses-assets/android.png',
            name: 'android',
            publishedAt: '2020-05-07T17:21:11.000Z',
            activeOnLean: false,
            isPrimary: true,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: 'not_started',
            isSystem: true,
            numberOfLessons: 8,
            nextLessonUrl: '/courses/android/lessons/forceful_browsing',
        },
        {
            id: 21,
            uuid: 'cc94d77d-8d1d-4c63-9a1f-36bf50f0d79d',
            displayName: 'Angular 2+',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            tagline: 'Learn how to secure Angular 2+ web applications.',
            iconUrl: 'https://codebashing-dev-content.s3-eu-west-1.amazonaws.com/courses-assets/angular.svg',
            name: 'angular',
            publishedAt: '2020-06-14T13:07:45.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: 'not_started',
            isSystem: true,
            numberOfLessons: 8,
            nextLessonUrl: '/courses/angular/lessons/anti_xss_mechanism_html_sanitaizer',
        },
        {
            id: 13,
            uuid: '66a71a0b-929d-4872-be0e-54ac775e0cd9',
            displayName: '.NET Advanced',
            description: 'Learn how to secure .NET web applications and practice recognizing different attacks.',
            tagline: 'Practice and learn how to secure .NET web applications.',
            iconUrl: 'https://codebashing-dev-content.s3.eu-west-1.amazonaws.com/courses-assets/NET_Advanced_1_Course_Icon.svg',
            name: 'dotnet_advanced_lessons',
            publishedAt: '2020-05-07T12:12:02.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: 'not_started',
            isSystem: true,
            numberOfLessons: 10,
            nextLessonUrl: '/courses/dotnet_advanced_lessons/lessons/second_order_sql_injection',
        },
        {
            id: 24,
            uuid: '42382720-e474-4765-afdc-536d8d586389',
            displayName: '.NET - API Security',
            description: 'Learn about the OWASP API Security Top 10 - covering all aspects, including the vulnerabilities, why they exist, exploits, and defenses.',
            tagline: 'Learn how to protect against API vulnerabilities.',
            iconUrl: 'https://management.devcodebashing.com/assets/v2/content/courses/dotnet/dotnet-e5236382623b3572dcdb6e99c09ec2dbd2e35ec279d7c3e210dc5fffabb7a74f.png',
            name: 'dotnet_api_security',
            publishedAt: '2020-12-10T16:01:41.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: 'not_started',
            isSystem: true,
            numberOfLessons: 8,
            nextLessonUrl: '/courses/dotnet_api_security/lessons/authentication_credentials_in_url',
        },
        {
            id: 15,
            uuid: '760fc927-9b0d-4832-ac40-35789f9c2f25',
            displayName: '.NET',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            tagline: 'Learn how to secure .NET web applications.',
            iconUrl: 'https://content.codebashing.com/courses-assets/4b48720d-5b79-43db-89e9-cff492f140a5.png',
            name: 'dotnet',
            publishedAt: '2020-05-07T15:27:44.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 1000,
            completionPercentage: 9.09000015258789,
            progress: 'started',
            isSystem: true,
            numberOfLessons: 22,
            nextLessonUrl: '/courses/dotnet/lessons/sql_injection',
        },
        {
            id: 39,
            uuid: '7e2c1b36-c812-4900-af98-c95251a6d7eb',
            displayName: 'testNana change name 2',
            description: 'lesson description',
            tagline: '',
            iconUrl: 'https://content.devcodebashing.com/courses-assets/angular.svg',
            name: 'testnana_change_name_2',
            publishedAt: '2022-07-04T09:34:04.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: null,
            isSystem: true,
            numberOfLessons: 1,
            nextLessonUrl: '/courses/testnana_change_name_2/lessons/demo_lesson',
        },
        {
            id: 41,
            uuid: '4df2555f-4592-4135-96ee-d957de5504b9',
            displayName: 'course builder course name edited',
            description: 'course builder desc edited',
            tagline: 'tagline 111111',
            iconUrl: null,
            name: 'course_builder_course_name_edited',
            publishedAt: '2022-08-09T11:49:50.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: null,
            isSystem: true,
            numberOfLessons: 5,
            nextLessonUrl: '/courses/course_builder_course_name_edited/lessons/access_management',
        },
        {
            id: 240,
            uuid: '0e2798f6-8e47-4639-9d4c-082d6ab0bea5',
            displayName: 'CISO test',
            description: 'CISO test',
            tagline: 'CISO test',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customCourses/customCourse-1.svg',
            name: 'learning_panel_ciso_test_1697964062',
            publishedAt: '2023-10-22T08:41:02.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: true,
            dueDate: null,
            score: 0,
            completionPercentage: 0,
            progress: 'not_started',
            isSystem: false,
            numberOfLessons: 2,
            nextLessonUrl: '/courses/custom_lessons/lessons/ciso_test1697964012?custom_course_name=learning_panel_ciso_test_1697964062',
        },
    ],
    lessons: [
        {
            id: 152,
            uuid: '6167f23e8df887fa6176a60d',
            displayName: 'Privileged Interface Exposure',
            description: 'Privileged Interface Exposure is a type of application weakness whereby a privileged (administration) interface is accessible to regular (low-privileged) users of the system. Because administration interfaces are only used by trusted administrator users, they are often overlooked from a security perspective. When exposed to the public Internet a malicious attacker could use the interface to her advantage. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/privileged_interface_exposure.png',
            name: 'privileged_interface_exposure',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A5: Security Misconfiguration ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/privileged_interface_exposure',
        },
        {
            id: 144,
            uuid: '6167f2408df887dad076a616',
            displayName: 'XXE Processing',
            description: 'XML External Entity (XXE) Processing is a type of application security vulnerability whereby a malicious user can attack poorly configured/implemented XML parser within an application. Malicious external entity references can be forced by an attacker, which results in unauthorized read-access to sensitive files on the server that the XML parser runs from. Denial of Service is another potential outcome. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/xxe_processing.png',
            name: 'xxe_processing',
            type: 'system',
            activeOnLean: true,
            isCompleted: true,
            progress: 'completed',
            cwe: 'CWE-611',
            owasp: 'A5: Security Misconfiguration ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: '500',
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/xxe_processing',
        },
        {
            id: 153,
            uuid: '6167f23e2479f15231d557dd',
            displayName: 'Leftover Debug Code',
            description: 'A common development practice is to add back door code specifically designed for debugging or testing purposes that is not intended to be shipped or deployed with the application. When this sort of debug code is accidentally left in the application',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/leftover_debug_code.png',
            name: 'leftover_debug_code',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-489',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/leftover_debug_code',
        },
        {
            id: 157,
            uuid: '6167f23dc27d3d218a9529fb',
            displayName: 'Horizontal Privilege Escalation',
            description: 'Horizontal Privilege Escalation is an application vulnerability that allows one (normal) User of an application to create, read, update and/or delete the data belonging to another (normal) User. This type of vulnerability is often the result of errors in the authorization logic. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/horizontal_privilege_escalation.png',
            name: 'horizontal_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/horizontal_privilege_escalation',
        },
        {
            id: 159,
            uuid: '6167f23cc27d3db1409529f8',
            displayName: 'Cross Site Request Forgery (POST)',
            description: 'Cross-Site Request Forgery (CSRF) is an application security vulnerability  that permits an attacker to force another logged-in user of the application to perform actions within that application without realising. The classic example is Bob and Alice both being logged-in users of an online banking application, and Bob tricks Alice into making a funds transfer to Bobs account with CSRF. Importantly, in CSRF attacks the attacker does not have a direct mechanism for seeing the applications response to the victim. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/cross_site_request_forgery_post.png',
            name: 'cross_site_request_forgery_post',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-352',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#12',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/cross_site_request_forgery_post',
        },
        {
            id: 155,
            uuid: '6167f23f2479f1ecb9d557e0',
            displayName: 'Session Exposure Within URL',
            description: 'The most common flaw is simply not encrypting sensitive data. When crypto is employed, weak key generation and management, and weak algorithm usage is common, particularly weak password hashing techniques. Browser weaknesses are very common and easy to detect, but hard to exploit on a large scale. External attackers have difficulty detecting server side flaws due to limited access and they are also usually hard to exploit. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/session_exposure_within_url.png',
            name: 'session_exposure_within_url',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-613',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/session_exposure_within_url',
        },
        {
            id: 158,
            uuid: '6167f2402479f1f94dd557e6',
            displayName: 'Vertical Privilege Escalation',
            description: 'Missing Function Level Access Control is an application vulnerability that allows either an Anonymous User or Legitimate User of the application to access the create, read, update and/or delete functionality belonging to another user of the application. This example we show how Vertical Privilege Escalation is a potential outcome of this vulnerability. Play Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/vertical_privilege_escalation.png',
            name: 'vertical_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/vertical_privilege_escalation',
        },
        {
            id: 150,
            uuid: '6167f23c8df887633876a607',
            displayName: 'DOM XSS',
            description: 'Document Object Model (DOM) Based XSS is a type of XSS attack wherein the attackers payload is executed as a result of modifying the DOM âenvironmentâ in the victimâs browser used by the original client side script, so that the client side code runs in an âunexpectedâ manner. That is, the page itself (the HTTP response that is) does not change, but the client side code contained in the page executes differently due to the malicious modifications that have occurred in the DOM environment. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/dom_xss.png',
            name: 'dom_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-79',
            owasp: 'A3: Injection',
            sans: 'SANS-#4',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/dom_xss',
        },
        {
            id: 149,
            uuid: '6167f23f2479f1d557d557e3',
            displayName: 'Stored (Persistent) XSS',
            description: 'Persistent Cross-Site Scripting (XSS) is an application vulnerability whereby a malicious user tricks a web application into storing attacker-supplied script code which is then later served to unsuspecting user(s) of the application. The attacker-supplied script code runs on the client-side system of other end user(s) of the application. This type of vulnerability is widespread and affects web applications that utilize (unvalidated) user-supplied input to generate (unencoded) application output, that is served to users. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/stored_persistent_xss.png',
            name: 'stored_persistent_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/stored_persistent_xss',
        },
        {
            id: 11,
            uuid: '6167f22d2479f1e989d557aa',
            displayName: 'DOM XSS',
            description: 'Document Object Model (DOM) Based XSS is a type of XSS attack wherein the attackers payload is executed as a result of modifying the DOM âenvironmentâ in the victimâs browser used by the original client side script, so that the client side code runs in an âunexpectedâ manner. That is, the page itself (the HTTP response that is) does not change, but the client side code contained in the page executes differently due to the malicious modifications that have occurred in the DOM environment. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/dom_xss.png',
            name: 'dom_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-79',
            owasp: 'A3: Injection',
            sans: 'SANS-#4',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/dom_xss',
        },
        {
            id: 164,
            uuid: '6167f23b2479f1f9d0d557d4',
            displayName: 'Vulnerable and Outdated Components',
            description: 'Code libraries, both proprietary and third-party, need constant maintenance and updates. Even if proprietary code is 100% secure, failure to update third-party components, and particularly updates that mitigate security vulnerabilities, will likely leave environments vulnerable to attack.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/components_with_known_vulnerabilities.png',
            name: 'components_with_known_vulnerabilities',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-1035',
            owasp: 'A6: Vulnerable and Outdated Components ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/components_with_known_vulnerabilities',
        },
        {
            id: 163,
            uuid: '6167f23d2479f10114d557da',
            displayName: 'Insecure Object Deserialization',
            description: 'Insecure Object Deserialization is a security vulnerability that permits an attacker to abuse application logic, deny service, or execute arbitrary code, when an object is being deserialized.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_object_deserialization.png',
            name: 'insecure_object_deserialization',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-502',
            owasp: 'A8: Software and Data Integrity Failures',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Java',
            url: '/courses/java/lessons/insecure_object_deserialization',
        },
        {
            id: 9,
            uuid: '6167f230c27d3d714e9529d5',
            displayName: 'Stored (Persistent) XSS',
            description: 'Persistent Cross-Site Scripting (XSS) is an application vulnerability whereby a malicious user tricks a web application into storing attacker-supplied script code which is then later served to unsuspecting user(s) of the application. The attacker-supplied script code runs on the client-side system of other end user(s) of the application. This type of vulnerability is widespread and affects web applications that utilize (unvalidated) user-supplied input to generate (unencoded) application output, that is served to users. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/stored_persistent_xss.png',
            name: 'stored_persistent_xss',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/stored_persistent_xss',
        },
        {
            id: 5,
            uuid: '6167f22c2479f139b4d557a4',
            displayName: 'Command Injection',
            description: 'A Command Injection vulnerability, when exploited by a malicious user, results in execution of arbitrary system commands on the host operating system. Command Injection attacks are possible when an application passes unsafe user supplied data (forms, cookies, HTTP headers, etc) to a system command. The malicious system command is run server side with the same privileges as the application. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/command_injection.png',
            name: 'command_injection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-77',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/command_injection',
        },
        {
            id: 12,
            uuid: '6167f22e2479f1ae30d557b0',
            displayName: 'Privileged Interface Exposure',
            description: 'Privileged Interface Exposure is a type of application weakness whereby a privileged (administration) interface is accessible to regular (low-privileged) users of the system. Because administration interfaces are only used by trusted administrator users, they are often overlooked from a security perspective. When exposed to the public Internet a malicious attacker could use the interface to her advantage. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/privileged_interface_exposure.png',
            name: 'privileged_interface_exposure',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A5: Security Misconfiguration ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/privileged_interface_exposure',
        },
        {
            id: 15,
            uuid: '6167f22fc27d3d093d9529d2',
            displayName: 'Session Exposure Within URL',
            description: 'The most common flaw is simply not encrypting sensitive data. When crypto is employed, weak key generation and management, and weak algorithm usage is common, particularly weak password hashing techniques. Browser weaknesses are very common and easy to detect, but hard to exploit on a large scale. External attackers have difficulty detecting server side flaws due to limited access and they are also usually hard to exploit. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/session_exposure_within_url.png',
            name: 'session_exposure_within_url',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-613',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/session_exposure_within_url',
        },
        {
            id: 6,
            uuid: '6167f2302479f16fd7d557b6',
            displayName: 'Use of Insufficiently Random Values',
            description: 'Insufficiently Random Values are an application security vulnerability whereby the application generates predictable values in sensitive areas of code that absolutely require strict randomness (unpredictability). As a result it may be possible for an attacker to predict the next value generated by the application to defeat cryptographic routines, access sensitive information, or impersonate another user. Play and Learn...\r\n',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/use_of_insufficiently_random_values.png',
            name: 'use_of_insufficiently_random_values',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-330',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/use_of_insufficiently_random_values',
        },
        {
            id: 4,
            uuid: '6167f2308df887809a76a5e3',
            displayName: 'SQL Injection',
            description: 'SQL Injection is a type of application security vulnerability whereby a malicious user is able to manipulate the SQL statements that the application sends to the backend database server for execution. A successful SQL injection attack exposes the data of the underlying database directly to the attacker. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/sql_injection.png',
            name: 'sql_injection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-89',
            owasp: 'A3: Injection',
            sans: 'SANS-#1',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/sql_injection',
        },
        {
            id: 14,
            uuid: '6167f22b8df88726d076a5d1',
            displayName: 'Authentication Credentials In URL',
            description: 'Insecure Logging is a type of application security vulnerability whereby the application is configured to either log sensitive data to log files (such as personally identifiable information, payment card information, or authentication credentials etc). Furthermore, if the application is not correctly validating user-supplied input that is then stored in logs, an attacker is able to maliciously manipulate log files. Play and Learn...\r\n\r\n\r\n',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/authentication_credentials_in_url.png',
            name: 'authentication_credentials_in_url',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-522',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/authentication_credentials_in_url',
        },
        {
            id: 13,
            uuid: '6167f22ec27d3d4f659529cf',
            displayName: 'Leftover Debug Code',
            description: 'A common development practice is to add back door code specifically designed for debugging or testing purposes that is not intended to be shipped or deployed with the application. When this sort of debug code is accidentally left in the application',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/leftover_debug_code.png',
            name: 'leftover_debug_code',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-489',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/leftover_debug_code',
        },
        {
            id: 16,
            uuid: '6167f2318df887146076a5e6',
            displayName: 'User Enumeration',
            description: 'User Enumeration is a type of application security vulnerability whereby the vulnerable web application reveals whether a username (email address or account name) exists or not, this can be a consequence of a misconfiguration or a design decision. The information obtained via user enumeration can then be used by an attacker to gain a list of users on system. This information can  be used to further attack the web application, for example, such as through a brute force credential guessing attack. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/user_enumeration.png',
            name: 'user_enumeration',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-203',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/user_enumeration',
        },
        {
            id: 17,
            uuid: '6167f22d8df887214c76a5da',
            displayName: 'Horizontal Privilege Escalation',
            description: 'Horizontal Privilege Escalation is an application vulnerability that allows one (normal) User of an application to create, read, update and/or delete the data belonging to another (normal) User. This type of vulnerability is often the result of errors in the authorization logic. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/horizontal_privilege_escalation.png',
            name: 'horizontal_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/horizontal_privilege_escalation',
        },
        {
            id: 7,
            uuid: '6167f22f2479f1e972d557b3',
            displayName: 'Session Fixation',
            description: 'Session Fixation is a type of application vulnerability where an application does not correctly renew session tokens when changing from a pre-login to post-login state. The same pre-login session token should not be used post-login, otherwise an attacker has the potential to steal authenticated sessions of legitimate users. When a session of one user is stolen by another, it is known as a hijacked session. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/session_fixation.png',
            name: 'session_fixation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-384',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/session_fixation',
        },
        {
            id: 10,
            uuid: '6167f22d8df887b39c76a5d7',
            displayName: 'Directory (Path) Traversal',
            description: 'Directory (Path) Traversal is an application vulnerability that allows an attacker to access directories and  files that are stored outside the web root folder. This type of vulnerability is found in applications that make insecure references to files based on user supplied input. A classic example is manipulating file location input variables with “dot-dot-slash (../)” sequences and its variations, to access arbitrary files and directories of the servers file system, such as sourcecode or password files, or other sensitive files. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/directory_path_traversal.png',
            name: 'directory_path_traversal',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-22',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#13',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/directory_path_traversal',
        },
        {
            id: 21,
            uuid: '6167f22e8df887535876a5dd',
            displayName: 'Insecure URL Redirect',
            description: 'Unvalidated redirects and forwards are possible when a web application accepts untrusted input that could cause the web application to redirect the request to a URL contained within untrusted input. By modifying untrusted URL input to a malicious site, an attacker may successfully launch a phishing scam and steal user credentials.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_url_redirect.png',
            name: 'insecure_url_redirect',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-601',
            owasp: 'A1: Broken Access Control ',
            sans: 'SANS-#22',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/insecure_url_redirect',
        },
        {
            id: 22,
            uuid: '6167f22e2479f12c77d557ad',
            displayName: 'Insecure TLS Validation',
            description: 'Insecure TLS validation is a security vulnerability that permits an attacker to bypass SSL pinning.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/insecure_tls_validation.png',
            name: 'insecure_tls_validation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-295',
            owasp: 'A2: Cryptographic Failures',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/insecure_tls_validation',
        },
        {
            id: 23,
            uuid: '6167f22c8df887177e76a5d4',
            displayName: 'Vulnerable and Outdated Components',
            description: 'Code libraries, both proprietary and third-party, need constant maintenance and updates. Even if proprietary code is 100% secure, failure to update third-party components, and particularly updates that mitigate security vulnerabilities, will likely leave environments vulnerable to attack.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/components_with_known_vulnerabilities.png',
            name: 'components_with_known_vulnerabilities',
            type: 'system',
            activeOnLean: true,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-1035',
            owasp: 'A6: Vulnerable and Outdated Components ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/components_with_known_vulnerabilities',
        },
        {
            id: 25,
            uuid: '6167f2158df887312f76a58a',
            displayName: 'Stack Overflows - Primer',
            description: 'Part 1 will introduce concepts we’ll extend upon. This module will give you a brief introduction on how stack data structures are used to keep track of function/subroutines calls, specifically looking at how C/C++ programs save return addresses, parameters and local variables on the stack.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_stack_p1.png',
            name: 'c_stack_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-121',
            owasp: 'A3: Injection',
            sans: 'SANS-#3',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_stack_p1',
        },
        {
            id: 26,
            uuid: '6167f215c27d3d7c7395297c',
            displayName: 'Stack Overflows',
            description: 'Part 2 will focus on memory corruption of the stack. This module will allow you to interact with insecure code and show how important stack components can be overwritten to alter program flow.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_stack_p2.png',
            name: 'c_stack_p2',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-121',
            owasp: 'A3: Injection',
            sans: 'SANS-#3',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_stack_p2',
        },
        {
            id: 27,
            uuid: '6167f2162479f1670ad5575c',
            displayName: 'Off By One Overflow',
            description: 'An off by one overflow is a type of buffer overflow vulnerability that allows overflowing a buffer by one byte outside the space allocated. The following tutorial will demonstrate an off-by-one overflow vulnerability and presents remediation techniques and solutions to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_stack_p3.png',
            name: 'c_stack_p3',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-193',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_stack_p3',
        },
        {
            id: 20,
            uuid: '6167f22bc27d3de5c39529c7',
            displayName: 'Click Jacking',
            description: 'Clickjacking, also known as a UI redress attack, is when an attacker uses multiple transparent or opaque layers to trick a user into clicking on a button or link on another page when they were intending to click on the the top level page. Thus, the attacker is hijacking clicks meant for their page and routing them to another page, most likely owned by another application, domain, or both.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/click_jacking.png',
            name: 'click_jacking',
            type: 'system',
            activeOnLean: true,
            isCompleted: true,
            progress: 'completed',
            cwe: 'CWE-451',
            owasp: 'A4: Insecure Design',
            sans: null,
            potentialPoints: 1000,
            doneRecently: true,
            earnedPoints: '1000',
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/click_jacking',
        },
        {
            id: 35,
            uuid: '6167f2168df88714cc76a58d',
            displayName: 'Clearing Memory',
            description: 'In C/C++ applications, it is often useful to wipe data from memory once it is no longer needed. However, if not performed, applications are exposed to information disclosure vulnerabilities . The following module will cover the basics of how to clear process memory and present techniques and solutions to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/clearing_memory_p1.png',
            name: 'clearing_memory_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-244',
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/clearing_memory_p1',
        },
        {
            id: 18,
            uuid: '6167f231c27d3d9a1b9529d8',
            displayName: 'Vertical Privilege Escalation',
            description: 'Missing Function Level Access Control is an application vulnerability that allows either an Anonymous User or Legitimate User of the application to access the create, read, update and/or delete functionality belonging to another user of the application. This example we show how Vertical Privilege Escalation is a potential outcome of this vulnerability. Play Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/vertical_privilege_escalation.png',
            name: 'vertical_privilege_escalation',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-265',
            owasp: 'A1: Broken Access Control ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Go',
            url: '/courses/go/lessons/vertical_privilege_escalation',
        },
        {
            id: 28,
            uuid: '6167f213c27d3daf04952976',
            displayName: 'Heap Introduction',
            description: 'The following tutorial will give you a brief introduction on how dynamic memory allocation makes use of the heap, how the malloc family of functions creates and manages chunks of in use, and free, memory. Additionally we will see how memory linked lists are managed via unlink.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_heap_p1.png',
            name: 'c_heap_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-122',
            owasp: 'A3: Injection',
            sans: 'SANS-#20',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_heap_p1',
        },
        {
            id: 32,
            uuid: '6167f2132479f1e58cd55750',
            displayName: 'Format String - Primer',
            description: 'Part 1 will focus on refreshing how format strings and format specifiers work at an in-memory level.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_formatstring_p1.png',
            name: 'c_formatstring_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-134',
            owasp: 'A3: Injection',
            sans: 'SANS-#23',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_formatstring_p1',
        },
        {
            id: 30,
            uuid: '6167f2148df88723d476a587',
            displayName: 'Heap Overflows',
            description: 'Part 2 will focus on memory corruption of the heap. This module will allow you to interact with insecure code and show how important heap components can be overwritten, a first step for attackers to execute arbitrary code.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_heap_p3.png',
            name: 'c_heap_p3',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-122',
            owasp: 'A3: Injection',
            sans: 'SANS-#20',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_heap_p3',
        },
        {
            id: 34,
            uuid: '6167f2132479f1a003d55753',
            displayName: 'Format String Server Attack',
            description: 'In this module, we will exploit a real format string vulnerability present within a remote secure access server. The techniques used for exploitation will help us demonstrate format string vulnerabilities and further present remediation techniques to prevent against such attacks.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_formatstring_p3.png',
            name: 'c_formatstring_p3',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-134',
            owasp: 'A3: Injection',
            sans: 'SANS-#23',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_formatstring_p3',
        },
        {
            id: 37,
            uuid: '6167f216c27d3dbaf195297f',
            displayName: 'Compiler Optimizations Bugs',
            description: 'Compiler optimization issues occur when compliers remove security critical code sections during the code optimization process. The following module will cover the basics of compiler optimization vulnerabilities and present techniques and solutions to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/compiler_optimizations_bugs_p1.png',
            name: 'compiler_optimizations_bugs_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-733',
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/compiler_optimizations_bugs_p1',
        },
        {
            id: 29,
            uuid: '6167f2142479f1a117d55756',
            displayName: 'Heap Overflows - Primer',
            description: 'Part 1 will introduce concepts we’ll extend upon. This module will give you a brief introduction on what dynamic memory structures look like, including memory meta data.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_heap_p2.png',
            name: 'c_heap_p2',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-122',
            owasp: 'A3: Injection',
            sans: 'SANS-#20',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_heap_p2',
        },
        {
            id: 39,
            uuid: '6167f2172479f11a88d55762',
            displayName: 'Race Conditions',
            description: 'Race conditions arise from multiple processes/threads that operate on related entities in an OS that has preemptive scheduling. This module explains race condition issues and their exploits, and presents a few techniques that help avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/race_conditions_p1.png',
            name: 'race_conditions_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-362',
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/race_conditions_p1',
        },
        {
            id: 31,
            uuid: '6167f214c27d3deefb952979',
            displayName: 'Integer Overflows - Primer',
            description: 'In this lesson, we will introduce a common insecure design pattern for Integer Overflows. This module will allow you to interact with insecure code and show how Integer Overflows can lead to memory corruption, a first step for attackers to execute arbitrary code.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_integer_p1.png',
            name: 'c_integer_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-190',
            owasp: 'A3: Injection',
            sans: 'SANS-#24',
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_integer_p1',
        },
        {
            id: 36,
            uuid: '6167f2162479f1202ad5575f',
            displayName: 'Dangerous or Insecure Use Of API',
            description: 'The following module will give you a brief introduction on how common APIs if implemented incorrectly can cause side effects that a malicious user can exploit to cause unexpected behavior, such as execution of unauthorized commands. We will also see the  possible techniques and solution to avoiding such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/dangerous_use_of_api_p1.png',
            name: 'dangerous_use_of_api_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-749',
            owasp: 'A6: Vulnerable and Outdated Components ',
            sans: 'SANS-#16',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/dangerous_use_of_api_p1',
        },
        {
            id: 33,
            uuid: '6167f213c27d3d0a37952973',
            displayName: 'Format String Attacks',
            description: 'Part 2 will focus on insecure use of format strings and how they can be used by an attacker to read arbitrary values from the program stack',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/c_formatstring_p2.png',
            name: 'c_formatstring_p2',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-134',
            owasp: 'A3: Injection',
            sans: 'SANS-#23',
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/c_formatstring_p2',
        },
        {
            id: 38,
            uuid: '6167f2178df887aed376a590',
            displayName: 'NULL Pointer Dereference',
            description: 'A NULL pointer dereference occurs when the application dereferences a pointer that it expects to be valid, but is NULL, typically causing a crash or exit. The following module explains NULL pointer dereference issues and presents possible techniques and solution to avoid such issues.',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses/cplus/icons/null_pointer_dereference_p1.png',
            name: 'null_pointer_dereference_p1',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-476',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'C/C++',
            url: '/courses/cplus/lessons/null_pointer_dereference_p1',
        },
        {
            id: 627,
            uuid: '7f1043d4-fab7-445b-ab47-c35e771f7a25',
            displayName: 'CISO test 2',
            description: 'CISO test 2',
            duration: '',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customLessons/customLesson-1.svg',
            name: 'ciso_test_21698172743',
            type: 'custom',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: null,
            url: '/courses/custom_lessons/lessons/ciso_test_21698172743',
        },
        {
            id: 621,
            uuid: '66fc9fed-2c97-43b4-a93f-f75c4f1f525a',
            displayName: 'CISO Test',
            description: 'dfdf',
            duration: '',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customLessons/customLesson-1.svg',
            name: 'ciso_test1697964012',
            type: 'custom',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: null,
            url: '/courses/custom_lessons/lessons/ciso_test1697964012',
        },
        {
            id: 587,
            uuid: '64915539f2c6b8701f4740c7',
            displayName: 'Unrestricted Resource Consumption',
            description: "This lesson covers Unrestricted Resource Consumption, formerly Lack of Resources and Rate Limiting (OWASP API4: 2019). We will discuss potential vulnerabilities in APIs  that don't restrict the number or size of resources a client requests, the potential impact of such attacks, their detection and exploitation, and their preventative actions.",
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/add13ee3-0987-47cc-a401-a489f6e62d05.svg',
            name: 'unrestricted_resource_consumption',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/unrestricted_resource_consumption',
        },
        {
            id: 586,
            uuid: '649d851f20007b3700e91749',
            displayName: 'Broken Object Property Level Authorization - Excessive data exposure',
            description: 'In the next lesson, you will learn about: “Broken Object Property Level Authorization,”  formerly the “Excessive Data Exposure” vulnerability (OWASP API3: 2019).  \nIt occurs when developers expose too much data to the client in their response.  You will understand how to detect it, the potential impacts of such an issue,  and its standard remediation methods.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/b1f68356-d43d-40e7-bcda-a7a79531a6fd.svg',
            name: 'broken_object_property_level_authorization',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/broken_object_property_level_authorization',
        },
        {
            id: 592,
            uuid: '64a1946981b81940e3da5094',
            displayName: 'Improper Inventory Management',
            description: 'This lesson covers “Improper Inventory Management,” \nformerly “Improper Asset Management” (OWASP API9: 2019). \nIt focuses on potential vulnerabilities that arise from poorly tracked, \nmonitored or secured API digital resources, their potential impact, \nand their detection, exploitation, and preventative actions.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/b948de38-baa5-49e5-ae50-f58f0e302bb9.svg',
            name: 'improper_inventory_management',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/improper_inventory_management',
        },
        {
            id: 588,
            uuid: '64a2816820007be388e9ada7',
            displayName: 'Security Misconfiguration',
            description: 'Learn how “Security Misconfigurations” can put your API at risk at any level, \nfrom the network to the application. \nTo ensure you’re fully aware of the important API security factors, \nwe’ll dive into specific aspects of each component, \nlike web servers, databases, and monitoring systems. \nBy exploring these components, you’ll become a pro \nand have a strong grasp of their security. \nDon’t worry; we’ll guide you through it all!',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/364d2e74-d1e8-49e0-a8c1-91d9e474f7ef.svg',
            name: 'security_misconfiguration',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/security_misconfiguration',
        },
        {
            id: 591,
            uuid: '64a28254b51cd275f18121c0',
            displayName: 'Insufficient Logging and Monitoring',
            description: 'In this lesson, you will learn about an important aspect of API security: \n“Insufficient Logging and Monitoring”. \nAttackers always look for vulnerabilities to exploit; \nIf insufficient logging and monitoring are in place, they can go undetected. \nTherefore, it is crucial to understand this aspect of API security \nand take proactive measures to protect your digital assets. \nSo, let’s dive in and explore how APIs must monitor and log events.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/9016f071-a891-43bd-bca5-4fc32820e964.svg',
            name: 'insufficient_logging_and_monitoring',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/insufficient_logging_and_monitoring',
        },
        {
            id: 590,
            uuid: '64a2827f81b8195e18da5ec0',
            displayName: 'Expression Language Injection',
            description: 'This lesson will explore the growing threat of “EL Injection.”\nAttackers can exploit EL Injection to access sensitive data and compromise your systems. \nHowever, with the proper knowledge, \nyou can defend yourself and prevent these attacks from succeeding. \nLet’s delve into EL Injection and learn how to protect yourself \nand your community from this dangerous vulnerability.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/475bd99e-e85c-4403-9fd7-55a83510f2df.svg',
            name: 'expression_language_injection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/expression_language_injection',
        },
        {
            id: 595,
            uuid: '64abe5fbb51cd23955827d90',
            displayName: ' Command Injections',
            description: 'In this lesson, you will learn about Command Injections.n\nHow a Command Injection attack is used to compromise the security of a back-end application nand how to write code more securely to protect against \nthese attacks.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/686d4516-c768-49e3-8e00-5ef9589eadff.svg',
            name: 'command_injections',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/command_injections',
        },
        {
            id: 600,
            uuid: '64abe6eeb51cd2ae75827ddc',
            displayName: 'Lack of Automated  Threat Protection',
            description: 'Automated threats are everywhere, \nand the chance of encountering one in APIs is \nsignificantly high!\n\nBe conscious of the various automated attacks out there, learn how to detect them, and prevent potential harm to your API. ',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/a1b3ef3e-7482-490e-8c83-c0b0dc657e62.svg',
            name: 'lack_of_automated_threat_protection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/lack_of_automated_threat_protection',
        },
        {
            id: 601,
            uuid: '64ae8ed6b51cd23f65831604',
            displayName: 'Broken Object Property Level Authorization - Mass Assignment',
            description: 'We have already covered Broken object property level authorization\nregarding excessive data exposure.  \nThis lesson covers “Mass Assignment” (OWASP API6:2019). \nIts definition, risks, impacts, how to detect and remediate it \nso APIs won’t be affected anymore, and so much more. \nBuckle up and brace yourself!',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/3d3157cc-d255-4056-8548-faad20d79445.svg',
            name: 'broken_object_property_level_authorization_mass_assignment',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'OWASP: Java - API Security ',
            url: '/courses/check/lessons/broken_object_property_level_authorization_mass_assignment',
        },
        {
            id: 384,
            uuid: '6167f2022479f1807bd5571d',
            displayName: ' Sensitive Data Exposure',
            description: 'Sensitive data, such as personally identifiable information, business secrets, and sensitive system information, must be protected from unauthorized access. Failure to do so can lead to data breaches, data thefts, business disruption, and even legal penalties. It is best to employ appropriate security controls for protecting the data being used by the application. Play and learn...',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/sensitive_data_exposure.svg',
            name: 'sensitive_data_exposure',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-540',
            owasp: 'A2: Cryptographic Failures',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Application Security for Decision Makers',
            url: '/courses/application_security_for_decision_makers/lessons/sensitive_data_exposure',
        },
        {
            id: 382,
            uuid: '6167f1ffc27d3df88a952935',
            displayName: ' Identification and Authentication Failures',
            description: 'Broken authentication is a security vulnerability caused due to faulty credential management and session management functionalities. An attacker can exploit the vulnerability by bypassing the authentication mechanism or stealing the session ID to gain unauthorized access to users accounts or other sensitive information. Play and learn...',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/broken_authentication.svg',
            name: 'broken_authentication',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-1028',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Application Security for Decision Makers',
            url: '/courses/application_security_for_decision_makers/lessons/broken_authentication',
        },
        {
            id: 120,
            uuid: '6167f207c27d3da0e395294a',
            displayName: ' Command Injection',
            description: 'A Command Injection vulnerability results in the execution of arbitrary system commands on the host operating system. Command Injection attacks are possible when an application passes unsafe user-supplied data (forms, cookies, HTTP headers, etc.) to a system command. The malicious system command is run server-side with the same privileges as the application. Play and Learn...',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/command_injection.png',
            name: 'command_injection',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-77',
            owasp: 'A3: Injection',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: '.NET: Backend Security Basics',
            url: '/courses/backend_dotnet/lessons/command_injection',
        },
        {
            id: 634,
            uuid: '65686076aeeb49a4225e052b',
            displayName: 'Access to Docker Registry',
            description: 'In this lesson, we will dive into the crucial role that image registries play within Docker infrastructure. \nWe will touch upon the potential security implications of unauthorized access to Docker registries and provide insights into how to detect, prevent, and remediate such vulnerabilities. ',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/b4951713-cc5f-4aff-97d0-2f3f8e20122d.svg',
            name: 'access_to_docker_registry',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Docker',
            url: '/courses/docker/lessons/access_to_docker_registry',
        },
        {
            id: 441,
            uuid: '61c43c8cf381131fc9513e57',
            displayName: 'Access Management',
            description: 'Access management for object storage is complex and full of nuances. Misconfiguration of these settings can lead to different security issues, such as sensitive data exposure. Preventing this requires knowledge of the different kinds of access settings and the interactions between them. Play and Learn…',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/6cdafe35-57fb-41d8-ab45-d1575093a1b3.svg',
            name: 'access_management',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'course builder course name edited',
            url: '/courses/course_builder_course_name_edited/lessons/access_management',
        },
        {
            id: 390,
            uuid: '6167f2038df887724776a557',
            displayName: ' Identification and Authentication Failures',
            description: 'Broken authentication is a security vulnerability caused due to faulty credential management and session management functionalities. An attacker can exploit the vulnerability by bypassing the authentication mechanism or stealing the session ID to gain unauthorized access to users accounts or other sensitive information. Play and learn...',
            duration: '5-8',
            iconUrl: 'https://codebashing-prod-eu-content.s3-eu-west-1.amazonaws.com/courses-assets/broken_authentication.svg',
            name: 'broken_authentication',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: 'CWE-1028',
            owasp: 'A7: Identification and Authentication Failures ',
            sans: null,
            potentialPoints: 1000,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Application Security for QA',
            url: '/courses/application_security_for_qa/lessons/broken_authentication',
        },
        {
            id: 82,
            uuid: '6167f271c27d3d571b952aab',
            displayName: 'Apex',
            description: 'Source codes is a library exposing vulnerable code and its remediated counter part. Skim through the dozens of different vulnerabilities according to your framework of choice. Review, learn and remediate your code faster.',
            duration: '5-8',
            iconUrl: 'https://content.codebashing.com/courses-assets/apex.png',
            name: 'apex',
            type: 'system',
            activeOnLean: false,
            isCompleted: false,
            progress: null,
            cwe: null,
            owasp: null,
            sans: null,
            potentialPoints: 0,
            doneRecently: false,
            earnedPoints: 0,
            assignedToMe: true,
            dueDate: null,
            systemCourseDisplayName: 'Source Code',
            url: '/courses/source_codes/lessons/apex',
        },
    ],
    skillTrees: [
        {
            name: 'Test',
            description: 'Skill Tree with C++',
            level: 'basic',
            duration: 318,
            createdAt: '2023-10-20T07:14:53.000Z',
            percent: 0,
            status: 'not_started',
            dueDate: null,
        },
        {
            name: 'Skill Tree with C++',
            description: 'Skill Tree with C++',
            level: 'basic',
            duration: 12,
            createdAt: '2023-10-17T10:40:27.000Z',
            percent: 0,
            status: 'not_started',
            dueDate: '2024-03-01T22:00:00.000Z',
        },
        {
            name: 'Security Champion',
            description: 'Become a Security Champion',
            level: 'Advanced',
            duration: 474,
            createdAt: '2023-10-08T16:52:00.000Z',
            percent: 0,
            status: 'started',
            dueDate: '2024-03-28T22:00:00.000Z',
        },
    ],
    learningPaths: [
        {
            name: 'check scorm player 111',
            description: 'A learning path for checking the scorm lessons 111',
            level: 'basic',
            duration: 60,
            createdAt: '2023-10-25T08:29:27.000Z',
            percent: 0,
            status: 'not_started',
            dueDate: '2024-01-28T22:00:00.000Z',
        },
        {
            name: 'Disney Learning Path Celebration!',
            description: 'Disney Learning Path Celebration',
            level: 'basic',
            duration: 160,
            createdAt: '2024-02-28T11:25:10.000Z',
            percent: 0,
            status: 'not_started',
            dueDate: '2024-01-30T22:00:00.000Z',
        },
    ],
};
exports.mockOtherMemebersTaken = {
    popularContent: {},
    team: {
        lessons: exports.mockLessons.lessons,
        courses: exports.mockCourses.courses,
        skillTrees: exports.mockSkillTree.skillTree,
        learningPaths: [],
        videoTutorials: [],
    },
    tenant: {
        lessons: exports.mockLessons.lessons,
        courses: exports.mockCourses.courses,
        skillTrees: [],
        learningPaths: [],
        videoTutorials: [],
    },
    success: true,
};
exports.mockCompletedData = {
    courses: [
        {
            uuid: '019684a8-a2af-4fbd-bb3f-06b31c45f635',
            displayName: 'chedva',
            description: 'cc',
            tagline: 'cc',
            iconUrl: 'https://content.codebashing.com/courses-assets/7487169c-4d81-4df8-82c6-e848f9a0bed4.webp',
            name: 'learning-panel_chedva_1711883954',
            publishedAt: '2024-03-31T11:19:14.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: false,
            dueDate: null,
            score: 0,
            completionPercentage: 100,
            progress: 'completed',
            hasCertificate: false,
            isSystem: false,
            numberOfLessons: 1,
            totalDuration: 5,
            quizStatus: 'attempts_exceeded',
        },
        {
            uuid: 'bfee8f0a-30e5-4fde-81d0-c12caffb783d',
            displayName: 'aasdasr',
            description: 'asdasdsad',
            tagline: 'asdasdsad',
            iconUrl: 'https://content.codebashing.com/courses-assets/7487169c-4d81-4df8-82c6-e848f9a0bed4.webp',
            name: 'learning-panel_aasdasr_1711898906',
            publishedAt: '2024-03-31T15:28:27.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: false,
            dueDate: null,
            score: 0,
            completionPercentage: 100,
            progress: 'completed',
            hasCertificate: false,
            isSystem: false,
            numberOfLessons: 1,
            totalDuration: 5,
            quizStatus: 'attempts_exceeded',
        },
        {
            uuid: '70b0a56d-97cc-435e-bed4-39d471194a99',
            displayName: 'anothercourse1',
            description: 'sdfdsfds',
            tagline: 'sdfdsfds',
            iconUrl: 'https://content.codebashing.com/courses-assets/7487169c-4d81-4df8-82c6-e848f9a0bed4.webp',
            name: 'learning-panel_anothercourse1_1711957673',
            publishedAt: '2024-04-01T07:47:53.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: false,
            dueDate: null,
            score: 0,
            completionPercentage: 100,
            progress: 'completed',
            hasCertificate: true,
            isSystem: false,
            numberOfLessons: 1,
            totalDuration: 5,
            quizStatus: 'completed',
        },
        {
            uuid: '715088b6-0264-45df-985f-d498120c4efc',
            displayName: 'aaaaaaaa',
            description: 'aaaaaaaaaa',
            tagline: 'aaaaaaaaaa',
            iconUrl: 'https://content.codebashing.com/courses-assets/7487169c-4d81-4df8-82c6-e848f9a0bed4.webp',
            name: 'learning-panel_aaaaaaaa_1711959858',
            publishedAt: '2024-04-01T08:24:18.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: false,
            dueDate: null,
            score: 0,
            completionPercentage: 100,
            progress: 'completed',
            hasCertificate: false,
            isSystem: false,
            numberOfLessons: 1,
            totalDuration: 5,
            quizStatus: 'attempts_exceeded',
        },
        {
            uuid: '6e423728-6c19-4ce9-b7c6-9b7e6e244f79',
            displayName: 'test100',
            description: '1111',
            tagline: '1111',
            iconUrl: 'https://content.codebashing.com/courses-assets/7487169c-4d81-4df8-82c6-e848f9a0bed4.webp',
            name: 'learning-panel_test100_1712664276',
            publishedAt: '2024-04-09T12:04:37.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: false,
            dueDate: null,
            score: 0,
            completionPercentage: 100,
            progress: 'completed',
            hasCertificate: true,
            isSystem: false,
            numberOfLessons: 1,
            totalDuration: 5,
            quizStatus: 'completed',
        },
        {
            uuid: 'b9f61e74-d212-424f-917e-4a25fd7f3ea8',
            displayName: 'testbot',
            description: 'boterd',
            tagline: 'boterd',
            iconUrl: 'https://content.codebashing.com/courses-assets/7487169c-4d81-4df8-82c6-e848f9a0bed4.webp',
            name: 'learning-panel_testbot_1712726778',
            publishedAt: '2024-04-10T05:26:18.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: false,
            dueDate: null,
            score: 0,
            completionPercentage: 100,
            progress: 'completed',
            hasCertificate: true,
            isSystem: false,
            numberOfLessons: 1,
            totalDuration: 5,
            quizStatus: 'completed',
        },
        {
            uuid: 'f3e1b3db-e0a8-42cf-b651-667c3bbd458d',
            displayName: 'CSRF',
            description: 'Discover how to defend against and prevent CSRF attacks.',
            tagline: 'Discover how to defend against and prevent CSRF attacks.',
            iconUrl: 'https://content.codebashing.com/courses-assets/5f28e9dc-6592-416c-a042-6de52511eeaf.svg',
            name: 'csrf',
            publishedAt: '2023-03-19T12:44:56.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: false,
            dueDate: null,
            score: 2900,
            completionPercentage: 100,
            progress: 'completed',
            hasCertificate: true,
            isSystem: true,
            numberOfLessons: 5,
            totalDuration: 25,
            quizStatus: null,
        },
        {
            uuid: 'e7b4e3b8-1a56-4f5f-8a79-bf14008efd6a',
            displayName: 'React',
            description: 'Learn how to secure React web applications and practice recognizing different attacks.',
            tagline: 'Practice and learn how to secure React web applications.',
            iconUrl: 'https://content.codebashing.com/courses-assets/3cdbfaa7-c0ae-4e84-b567-8f3e4872020e.svg',
            name: 'react',
            publishedAt: '2021-07-29T11:28:45.000Z',
            activeOnLean: false,
            isPrimary: false,
            assignedToMe: false,
            dueDate: null,
            score: 3500,
            completionPercentage: 100,
            progress: 'completed',
            hasCertificate: true,
            isSystem: true,
            numberOfLessons: 5,
            totalDuration: 25,
            quizStatus: null,
        },
    ],
    learningPaths: [
        {
            id: 28,
            uuid: '4dba27ed-f473-4242-ab3d-c52cfdf037b1',
            name: 'C+ Learning Path',
            description: 'C++ ',
            potentialScore: 150,
            duration: 12,
            level: 'beginner',
            createdAt: '2023-10-17T10:34:20.000Z',
            badge: null,
            dueDate: null,
            progress: {
                status: 'completed',
                startedAt: '2023-10-17T10:49:35.000Z',
                completedAt: '2023-11-09T22:12:57.000Z',
                points: 150,
            },
        },
    ],
    skillTrees: [
        {
            id: 40,
            uuid: '14ef11be-3767-4ff6-81eb-351baf68a5c8',
            name: 'Skill Tree with C++',
            description: 'Skill Tree with C++',
            duration: 12,
            level: 'basic',
            createdAt: '2023-10-17T10:40:27.000Z',
            potentialScore: 0,
            dueDate: null,
            progress: {
                status: 'completed',
                percent: 100,
                points: 1900,
                startedAt: '2024-03-27T07:25:24.000Z',
                completedAt: '2024-03-27T07:28:36.000Z',
            },
        },
    ],
    videoTutorials: [
        {
            id: 29,
            uuid: '4915a0bf-95b5-4a7b-96b0-fc1b099c523c',
            displayName: 'arie test 1',
            description: 'arie test 1',
            duration: '02:02:02',
            updatedAt: '2024-05-20T10:12:15.000Z',
            imageUrl: 'https://content.codebashing.com/courses-assets/23695013-c874-442d-b779-1a73afbb4802.svg',
            videoUrl: 'https://content.devcodebashing.com/video-tutorials/4915a0bf-95b5-4a7b-96b0-fc1b099c523c/video.mp4',
            createdAt: '2023-11-02T07:18:17.000Z',
            earnedPoints: '100',
            status: 'completed',
        },
        {
            id: 27,
            uuid: 'b30839af-2c3d-4d78-b70c-1986926c491d',
            displayName: '8',
            description: '8',
            duration: '02:01:06',
            updatedAt: '2024-05-20T10:12:15.000Z',
            imageUrl: 'https://content.codebashing.com/courses-assets/23695013-c874-442d-b779-1a73afbb4802.svg',
            videoUrl: 'https://content.devcodebashing.com/video-tutorials/b30839af-2c3d-4d78-b70c-1986926c491d/video.mp4',
            createdAt: '2023-08-10T10:22:32.000Z',
            earnedPoints: '100',
            status: 'completed',
        },
    ],
};
exports.mockUsersLeaderboarddData = {
    success: true,
    results: [
        {
            name: 'Rivka Reich dfmdskjfsdfd',
            profilePicture: null,
            totalScore: 108979,
            rank: 1,
        },
        {
            name: 'Masha =]',
            profilePicture: null,
            totalScore: 64860,
            rank: 2,
        },
        {
            name: 'Ronits',
            profilePicture: null,
            totalScore: 58601,
            rank: 3,
        },
        {
            name: 'Nirjhkjkרכר',
            profilePicture: null,
            totalScore: 40800,
            rank: 4,
        },
        {
            name: 'NCCX',
            profilePicture: null,
            totalScore: 38337,
            rank: 5,
        },
        {
            name: 'Yossi Rifold',
            profilePicture: null,
            totalScore: 31500,
            rank: 6,
        },
        {
            name: 'chedvkjja2',
            profilePicture: null,
            totalScore: 24000,
            rank: 7,
        },
        {
            name: 'User22214588',
            profilePicture: null,
            totalScore: 22039,
            rank: 8,
        },
        {
            name: 'arie testing test',
            profilePicture: null,
            totalScore: 15443,
            rank: 9,
        },
        {
            name: 'Val',
            profilePicture: null,
            totalScore: 14877,
            rank: 10,
        },
        {
            name: 'invited38',
            profilePicture: null,
            totalScore: 9599,
            rank: 11,
        },
        {
            name: 'Rivkazzz',
            profilePicture: null,
            totalScore: 8803,
            rank: 12,
        },
        {
            name: 'xz1',
            profilePicture: null,
            totalScore: 8555,
            rank: 13,
        },
        {
            name: 'invited40',
            profilePicture: null,
            totalScore: 8334,
            rank: 14,
        },
        {
            name: 'Miriam ( user )',
            profilePicture: null,
            totalScore: 5811,
            rank: 15,
        },
        {
            name: 'Yalishere <3',
            profilePicture: null,
            totalScore: 5732,
            rank: 16,
        },
        {
            name: 'Maria',
            profilePicture: null,
            totalScore: 2600,
            rank: 17,
        },
        {
            name: 'System test user',
            profilePicture: null,
            totalScore: 2500,
            rank: 18,
        },
        {
            name: 'cb_dev_test',
            profilePicture: null,
            totalScore: 250,
            rank: 19,
        },
        {
            name: 'BenKolin',
            profilePicture: null,
            totalScore: 250,
            rank: 20,
        },
        {
            name: 'Guy Freedom',
            profilePicture: null,
            totalScore: 250,
            rank: 21,
        },
        {
            name: 'valbolt',
            profilePicture: null,
            totalScore: 100,
            rank: 22,
        },
        {
            name: 'Ronit User',
            profilePicture: null,
            totalScore: 0,
            rank: 23,
        },
    ],
    total: 399,
    currentUser: {
        rank: 5,
        nickname: 'NCCX',
        profilePicture: null,
        totalScore: 38337,
    },
};
exports.mockTopUsersLeaderboarddData = {
    success: true,
    results: [
        {
            name: 'Rivka Reich dfmdskjfsdfd',
            profilePicture: null,
            totalScore: 108979,
            rank: 1,
        },
        {
            name: 'Masha =]',
            profilePicture: null,
            totalScore: 64860,
            rank: 2,
        },
        {
            name: 'Ronits',
            profilePicture: null,
            totalScore: 58601,
            rank: 3,
        },
        {
            name: 'Ronits',
            profilePicture: null,
            totalScore: 58601,
            rank: 3,
        },
        {
            name: 'Ronits',
            profilePicture: null,
            totalScore: 58601,
            rank: 3,
        },
        {
            name: 'Ronits',
            profilePicture: null,
            totalScore: 58601,
            rank: 3,
        },
        {
            name: 'Ronits',
            profilePicture: null,
            totalScore: 58601,
            rank: 3,
        },
        {
            name: 'Ronits',
            profilePicture: null,
            totalScore: 58601,
            rank: 3,
        },
        {
            name: 'Ronits',
            profilePicture: null,
            totalScore: 58601,
            rank: 3,
        },
        {
            name: 'Ronits',
            profilePicture: null,
            totalScore: 58601,
            rank: 3,
        },
    ],
    total: 399,
    currentUser: {
        rank: 5,
        name: 'NCCX',
        profilePicture: null,
        totalScore: 38337,
    },
};
exports.mockTeamsLeaderboarddData = {
    success: true,
    teams: [
        {
            rank: 1,
            name: 'Simba',
            totalScore: '11155',
            users: [
                {
                    rank: 1,
                    name: 'Ronit User',
                    profilePicture: null,
                    totalScore: 0,
                },
                {
                    rank: 2,
                    name: 'Maria',
                    profilePicture: null,
                    totalScore: 2600,
                },
                {
                    rank: 3,
                    name: 'xz1',
                    profilePicture: null,
                    totalScore: 8555,
                },
            ],
        },
        {
            rank: 2,
            name: 'Manager Team',
            totalScore: '9599',
            users: [
                {
                    rank: 1,
                    name: 'Ronit User',
                    profilePicture: null,
                    totalScore: 0,
                },
                {
                    rank: 2,
                    name: 'Manager',
                    profilePicture: null,
                    totalScore: null,
                },
                {
                    rank: 3,
                    name: 'invited38',
                    profilePicture: null,
                    totalScore: 9599,
                },
                {
                    rank: 4,
                    name: 'Confirmed12',
                    profilePicture: null,
                    totalScore: null,
                },
                {
                    rank: 5,
                    name: 'invited41',
                    profilePicture: null,
                    totalScore: null,
                },
            ],
        },
        {
            rank: 3,
            name: 'huihi',
            totalScore: '8803',
            users: [
                {
                    rank: 1,
                    name: 'Rivkazzz',
                    profilePicture: null,
                    totalScore: 8803,
                },
                {
                    rank: 2,
                    name: 'User52324512',
                    profilePicture: null,
                    totalScore: null,
                },
            ],
        },
    ],
    total: 25,
};
exports.mockHomePageBanners = {
    success: true,
    items: [
        [
            {
                contentType: 'course',
                percent: 25,
                isPrimary: 0,
                dueDate: null,
                uuid: 'cc94d77d-8d1d-4c63-9a1f-36bf50f0d79d',
                name: 'angular',
                displayName: 'Angular 2+',
                description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
                tagline: 'Learn how to secure Angular 2+ web applications.',
                iconUrl: 'https://content.codebashing.com/courses-assets/2c88d6a5-2645-4979-b6d4-5ee6e6df51a3.svg',
                type: 'system',
                publishedAt: '2020-06-14T13:07:45.000Z',
                createdAt: '2023-03-26T10:28:29.000Z',
                updatedAt: '2024-01-31T15:51:05.000Z',
            },
            {
                contentType: 'lesson',
                percent: 0,
                isPrimary: 0,
                dueDate: '2024-02-29T22:00:00.000Z',
                uuid: '6167f2498df887141376a634',
                name: 'authentication_credentials_in_url',
                displayName: 'Authentication Credentials In URL',
                description: 'Insecure Logging is a type of application security vulnerability whereby the application is configured to either log sensitive data to log files (such as personally identifiable information, payment card information, or authentication credentials etc). Furthermore, if the application is not correctly validating user-supplied input that is then stored in logs, an attacker is able to maliciously manipulate log files. Play and Learn...',
                activeOnFree: false,
                duration: '5-8',
                iconUrl: 'https://content.codebashing.com/courses-assets/authentication_credentials_in_url.png',
                hasChallenge: true,
                type: 'system',
                publishedAt: '2020-05-07T16:27:46.000Z',
                createdAt: '2023-03-21T08:19:42.000Z',
                updatedAt: '2024-01-31T14:42:13.000Z',
            },
            {
                contentType: 'lab',
                id: 123,
                uuid: 'abcd',
                displayName: 'Java hands on labs',
                description: 'Select your next expertise and follow a dynamic gamified learning to obtain your certification!',
                duration: '23',
                potentialScore: 30000,
                earnedScore: 200,
                name: ' Java hands on labs',
                isCompleted: false,
                progress: '25',
                tags: [
                    {
                        uuid: '60f81f54b3e1260b5cee0448',
                        name: 'frontend',
                        displayName: 'FrontEnd :)',
                    },
                    {
                        uuid: '61c98bddcdfbc8ca10eae27d',
                        name: 'use_of_insufficiently_random_values',
                        displayName: 'Use Of Insufficiently Random Values',
                    },
                    {
                        uuid: '63a991bb1d8f6f722a12ae1d',
                        name: 'anti_xss_mechanism_url_sanitaizer',
                        displayName: 'Anti Xss Mechanism Url Sanitaizer',
                    },
                ],
            },
        ],
    ],
};
